<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Enquiry Form - {{ EnqNo }}</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <FilterCBModal />
              <b-button v-if="!EnqNo" size="sm" @click="goToDomestic" variant="info">Generate Domestic Enquiry</b-button>
            </b-nav-form>
            </b-navbar-nav>

        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- <md-layout md-gutter  >
            <md-layout md-flex="75"></md-layout>
            <md-layout md-flex="25">
              <label>Enquiry Date</label>
              <date-picker
                lang="en"
                disabled
                name="enqDate"
                id="enqDate"
                v-model="ffExoprtDetail.enqDate"
              ></date-picker>
            </md-layout>
              </md-layout>-->
              <md-layout md-gutter>
                <md-layout md-flex="90" md-flex-small="100">
                  <label class="mt-2 mr-3" for="jobType">Job Type *</label>
                  <md-layout
                    v-for="(segmentNameArray, index) in showSegmentArray"
                    :key="index"
                    :md-flex="segmentNameArray.flex"
                    md-flex-small="100"
                  >
                    <!-- :disabled="ffExoprtDetail.allModuleId!=''?true:false" -->
                    <md-checkbox
                      v-model="ffExoprtDetail.jobType[index]"
                      class="md-primary"
                      :md-value="segmentNameArray.value"
                      :name="'jobType' + (index + 1)"
                      :id="'jobType' + (index + 1)"
                      :disabled="disbleEnquiry"
                      @change="jobTypeSelect(segmentNameArray.value, index)"
                    ></md-checkbox>
                    <h6 style="margin-top: 17px">
                      <b-badge variant="light">{{ segmentNameArray.show }}</b-badge>
                    </h6>
                  </md-layout>
                </md-layout>
                <!-- <md-layout
                  v-if="allFFDataTable.length>0 || allCCDataTable.length>0 || allTPTDataTable.length>0"
                  md-flex="10"
                  style="margin-top:5px"
                >
                  <b-button size="sm" v-b-modal.myDIV variant="outline-info">Existing Quote</b-button>
                </md-layout>-->
                <!-- <br />
                <h5>Select Existing Quotation</h5>-->
              </md-layout>
              <b-card
                style="background: whiteSmoke"
                v-if="
                  ffExoprtDetail.selectedFFQuotationId != '' ||
                  ffExoprtDetail.selectedCCQuotationId != '' ||
                  ffExoprtDetail.selectedTPTQuotationId != ''
                "
              >
                <md-layout md-gutter>
                  <md-layout
                    md-flex="25"
                    md-flex-small="100"
                    v-if="ffExoprtDetail.selectedFFQuotationId != ''"
                  >
                    <div v-for="(itemFF, index) in showFFSelectedExistQ" :key="index">
                      <h6>
                        <b-badge variant="info"
                          >Selected Existing Freight Quotation</b-badge
                        >
                      </h6>
                      <div v-if="itemFF.shipmentType == '1'">
                        <b>Container Type :</b>
                        {{ itemFF.multipleContainerType }}
                        <br />
                        <b>POR :</b>
                        {{ itemFF.POR }}
                        <br />
                        <b>Load Port :</b>
                        {{ itemFF.LP }}
                        <br />
                        <b>POD :</b>
                        {{ itemFF.POD }}
                        <br />
                        <b>FPOD :</b>
                        {{ itemFF.finalPlace }}
                      </div>
                      <div v-else>
                        <br />
                        <b>Departure Airport :</b>
                        {{ itemFF.departPort }}
                        <br />
                        <b>Destination Airport :</b>
                        {{ itemFF.destiPort }}
                      </div>
                      <br />
                      <b-button
                        v-if="
                          itemFF.ffQuotationPdf != '' && itemFF.ffQuotationPdf != null
                        "
                        size="sm"
                        variant="outline-success"
                        @click="PrintFF(itemFF.ffQuotationPdf)"
                        >View Quotation</b-button
                      >
                    </div>
                  </md-layout>
                  <md-layout
                    md-flex="5"
                    v-if="ffExoprtDetail.selectedCCQuotationId != ''"
                  ></md-layout>
                  <md-layout
                    md-flex="25"
                    md-flex-small="100"
                    v-if="ffExoprtDetail.selectedCCQuotationId != ''"
                  >
                    <div v-for="(itemCC, index2) in showCCSelectedExistQ" :key="index2">
                      <h6>
                        <b-badge variant="info"
                          >Selected Existing Custom Quotation</b-badge
                        >
                      </h6>
                      <b>Container Type :</b>
                      {{ itemCC.multipleContainerType }}
                      <br />
                      <b>POR :</b>
                      {{ itemCC.POR }}
                      <br />
                      <b-button
                        v-if="
                          itemCC.ccQuotationPdf != '' && itemCC.ccQuotationPdf != null
                        "
                        size="sm"
                        variant="outline-success"
                        @click="PrintCC(itemCC.ccQuotationPdf)"
                        >View Quotation</b-button
                      >
                    </div>
                  </md-layout>
                  <md-layout
                    md-flex="5"
                    v-if="ffExoprtDetail.selectedTPTQuotationId != ''"
                  ></md-layout>
                  <md-layout
                    md-flex="25"
                    md-flex-small="100"
                    v-if="ffExoprtDetail.selectedTPTQuotationId != ''"
                  >
                    <div v-for="(itemTPT, index) in showTPTSelectedExistQ" :key="index">
                      <h6>
                        <b-badge variant="info">Selected Existing TPT Quotation</b-badge>
                      </h6>
                      <b>Container Type :</b>
                      {{ itemTPT.multipleContainerType }}
                      <br />
                      <b>Pickup Location :</b>
                      {{ itemTPT.pickUp }}
                      <br />
                      <b>Handover Location :</b>
                      {{ itemTPT.handover }}
                      <br />
                      <b>Factory Location :</b>
                      {{ itemTPT.factoryLoc }}
                      <br />
                      <b-button
                        v-if="
                          itemTPT.tptQuotationPdf != '' && itemTPT.tptQuotationPdf != null
                        "
                        size="sm"
                        variant="outline-success"
                        @click="PrintTPT(itemTPT.tptQuotationPdf)"
                        >View Quotation</b-button
                      >
                    </div>
                  </md-layout>
                </md-layout>
              </b-card>
              <md-layout md-gutter>
                <md-layout md-flex="25" class="pr-2 pl-2" md-flex-small="100">
                  <label for="clientId">Client Type *</label>
                  <model-list-select
                    @input="fetchType"
                    :isDisabled="disbleEnquiry"
                    :list="clientTypeList"
                    id="clientNamenew"
                    v-model="ffExoprtDetail.clientType"
                    option-value="val"
                    option-text="type"
                    placeholder="Client Type"
                  ></model-list-select>
                  <span class="error" v-if="!ffExoprtDetail.clientType">{{
                    clientTypeError
                  }}</span>
                </md-layout>

                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="25" class="pl-2 pr-2" md-flex-small="100">
                  <label for="transportType">Shipping Type *</label>
                  <model-list-select
                    @input="getDataLocations"
                    :isDisabled="disbleEnquiry"
                    :list="shipmentTypeList"
                    v-model="ffExoprtDetail.shipmentType"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Shipment Type"
                  ></model-list-select>

                  <span class="error" v-if="!ffExoprtDetail.shipmentType">{{
                    shipmentTypeError
                  }}</span>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->

                <md-layout md-flex="20" class="pl-2 pr-2" md-flex-small="100">
                  <label for="transportType">Export / Import *</label>
                  <!-- <b-form-input :formatter="capitalizeAll"
                    v-if="ffExoprtDetail.clientType=='3'"
                    :disabled="true "
                    @change="getDataLocations"
                    id="newClientName"
                    name="newClientName"
                    v-model="ffExoprtDetail.transportType"
                  ></b-form-input>-->
                  <model-list-select
                    @input="getDataLocations()"
                    :isDisabled="disbleEnquiry || ffExoprtDetail.shipmentType == ''"
                    :list="transportTypeName"
                    v-model="ffExoprtDetail.transportType"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select"
                  ></model-list-select>
                  <span class="error" v-if="!ffExoprtDetail.transportType">{{
                    transportTypeError
                  }}</span>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout
                  md-flex="30"
                  class="pr-2 pl-2"
                  v-if="ffExoprtDetail.clientType != '2'"
                  md-flex-small="100"
                >
                  <label for="clientId">Client Name *</label>
                  <model-list-select
                    @input="getClientFactoryLoc"
                    :isDisabled="
                      disbleEnquiry ||
                      ffExoprtDetail.shipmentType == '' ||
                      ffExoprtDetail.transportType == ''
                    "
                    :list="getCLientData"
                    id="clientNamenew"
                    v-model="ffExoprtDetail.clientId"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Existing Client Name"
                  ></model-list-select>
                  <span class="error" v-if="!ffExoprtDetail.clientId">{{
                    clientIdError
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout
                md-gutter
                v-if="ffExoprtDetail.clientId && !ffExoprtDetail.mainEnquiryId"
              >
                <md-layout md-flex="50" md-flex-small="100" class="pr-2 pl-2">
                  <label for="transportType">Client Email & State</label>
                  <b-textarea
                    id="newClientAddress"
                    name="newClientAddress"
                    type="text"
                    v-model="clientIntro"
                  ></b-textarea>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="ffExoprtDetail.clientType == '2'">
                <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                  <label for="clientId">Lead Name *</label>
                  <!-- <b-form-input
                    :formatter="capitalizeAll"
                    :disabled="disbleEnquiry"
                    id="newClientName"
                    name="newClientName"
                    v-model="ffExoprtDetail.newClientName"
                  ></b-form-input> -->
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllLeadCompList']"
                    id="newClientName"
                    v-model="ffExoprtDetail.newClientName"
                    option-value="lead_comp_name"
                    option-text="lead_comp_name"
                    placeholder="Select Lead Name"
                    @input="LeadClientDetails()"
                  ></model-list-select>

                  <span class="error" v-if="!ffExoprtDetail.newClientName">{{
                    newClientNameError
                  }}</span>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                  <label for="clientId">Client Email *</label>

                  <b-form-input
                    :formatter="capitalizeAll"
                    id="newClientEmail"
                    name="newClientEmail"
                    v-model="ffExoprtDetail.newClientEmail"
                  ></b-form-input>
                  <span class="error" v-if="!ffExoprtDetail.newClientEmail">{{
                    newClientEmailError
                  }}</span>
                </md-layout>
                <!-- </md-layout>
                <md-layout md-gutter v-if="ffExoprtDetail.clientType=='2'">-->

                <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                  <label for="transportType">Contact No. *</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="newClientPhoneNumber"
                    name="newClientPhoneNumber"
                    type="text"
                    v-model="ffExoprtDetail.newClientPhoneNumber"
                  ></b-form-input>
                  <!-- {{ffExoprtDetail.newClientPhoneNumber}} -->
                  <span class="error" v-if="!ffExoprtDetail.newClientPhoneNumber">{{
                    newClientPhoneNumberError
                  }}</span>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                  <label for="transportType">Client Address *</label>
                  <b-textarea
                    id="newClientAddress"
                    name="newClientAddress"
                    type="number"
                    v-model="ffExoprtDetail.newClientAddress"
                  ></b-textarea>

                  <span class="error" v-if="!ffExoprtDetail.newClientAddress">{{
                    newClientAddressError
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter v-if="ffExoprtDetail.shipmentType == '1'">
                <md-layout
                  md-flex="50"
                  class="pr-2 pl-2"
                  md-flex-small="100"
                  v-if="hideCContatiner == false"
                >
                  <label for="AutoContainerType">Container Type *</label>
                  <!-- {{ ffExoprtDetail.shipmentType }}
                  {{ ffExoprtDetail.transportType }}
                  {{ ffExoprtDetail.multipleContainerType }} -->
                  <model-list-select
                    :isDisabled="
                      disbleEnquiry ||
                      (ffExoprtDetail.shipmentType == '1' &&
                        ffExoprtDetail.multipleContainerType[0] == 'LCL Container')
                        ? true
                        : false
                    "
                    :list="getContainerTypeData"
                    v-model="AutoContainerType"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </md-layout>
                <md-layout
                  md-flex="70"
                  md-flex-small="100"
                  v-if="ffExoprtDetail.multipleContainerType.length > 0"
                >
                  <md-chip
                    :disabled="disbleEnquiry"
                    style="margin-top: 38px"
                    md-deletable
                    v-for="(type, index) in ffExoprtDetail.multipleContainerType"
                    :key="index"
                    @delete="deleteContainer(type)"
                    >{{ type }}</md-chip
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label for="commodityType">Commodity Type</label>
                  <model-list-select
                    :list="commodityTypeName"
                    v-model="ffExoprtDetail.commodityType"
                    option-value="commodityTypeVal"
                    option-text="commodityTypeText"
                    placeholder="Select Commodity Type"
                  ></model-list-select>
                  <span class="error" v-if="!ffExoprtDetail.commodityType">{{
                    commodityTypeError
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Hazardous'">
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>IMDG Class</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="IMDGClass"
                      name="IMDGClass"
                      v-model="ffExoprtDetail.IMDGClass"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>UN Number</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="UNNumber"
                      name="UNNumber"
                      v-model="ffExoprtDetail.UNNumber"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="20" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Packing Code</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="packingCode"
                      name="packingCode"
                      v-model="ffExoprtDetail.packingCode"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Reefer'">
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Temperature Req(Degree Celsius)</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="temperatureRequired"
                      name="temperatureRequired"
                      v-model="ffExoprtDetail.temperatureRequired"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Others'">
                <md-layout md-flex="100" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Specific Detail if any..!</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="otherComodity"
                      name="otherComodity"
                      v-model="ffExoprtDetail.otherComodity"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <div class="accordion mt-1" role="tablist" v-if="hideTPTSection == false">
                <!-- <h5>   <b-badge class="mt-3" variant="info"  v-b-toggle.accordion-1 >Transportation</b-badge></h5> -->

                <b-collapse
                  id="accordion-1"
                  :visible="ffExoprtDetail.mainEnquiryId != '' ? true : showTPTAccordian"
                  accordion="my-accordion1"
                  role="tabpanel"
                >
                  <div>
                    <md-layout md-gutter v-if="hideTPTSection == false">
                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <label for="AutoPickupLocation">{{
                          newJobType.indexOf("TPT") >= 0
                            ? "Pickup Location *"
                            : "Pickup Location"
                        }}</label>
                        <!-- {{ffExoprtDetail+ffExoprtDetail.multipleContainerType[0]}}
                        {{newJobType}}-->
                        <model-list-select
                          v-if="
                            ffExoprtDetail.shipmentType == '1' &&
                            ffExoprtDetail.transportType == 'Export' &&
                            ffExoprtDetail.multipleContainerType[0] == 'LCL Container' &&
                            newJobType.indexOf('TPT') >= 0
                          "
                          :isDisabled="
                            ffExoprtDetail.shipmentType == '1' &&
                            ffExoprtDetail.transportType == 'Export' &&
                            ffExoprtDetail.multipleContainerType[0] == 'LCL Container' &&
                            newJobType.indexOf('TPT') >= 0
                              ? true
                              : false
                          "
                          id="down2"
                          @input="
                            getLocationList(
                              $event,
                              'Client_Factory',
                              'getAlllocationListDataFactory'
                            )
                          "
                          @searchchange="
                            getLocationList(
                              $event,
                              'Client_Factory',
                              'getAlllocationListDataFactory'
                            )
                          "
                          :list="allLocationListFactory"
                          v-model="ffExoprtDetail.pickupLocationId"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          :placeholder="
                            allLocationList.length > 0
                              ? 'Select Pickup Location'
                              : 'No Pickup Location'
                          "
                        ></model-list-select>
                        <model-list-select
                          v-else-if="ffExoprtDetail.shipmentType == '1'"
                          :isDisabled="disbleEnquiry"
                          @input="
                            getLocationList(
                              $event,
                              'Icd,Sea_Port_India',
                              'getAlllocationListData'
                            )
                          "
                          @searchchange="
                            getLocationList(
                              $event,
                              'Icd,Sea_Port_India',
                              'getAlllocationListData'
                            )
                          "
                          :list="allLocationList"
                          v-model="ffExoprtDetail.pickupLocationId"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          placeholder="Select Pickup Location"
                        ></model-list-select>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-else
                          :disabled="disbleEnquiry"
                          id="transporterName"
                          name="transporterName"
                          v-model="ffExoprtDetail.airPickup"
                        ></b-form-input>
                        <span class="error" v-if="!ffExoprtDetail.pickupLocationId">{{
                          pickupLocationIdError
                        }}</span>
                      </md-layout>

                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout
                        md-flex="50"
                        class="pr-2 pl-2"
                        v-if="ffExoprtDetail.shipmentType == '1'"
                        md-flex-small="100"
                      >
                        <label for="AutohandupLocation">{{
                          newJobType.indexOf("TPT") >= 0
                            ? "Handover Location *"
                            : "Handover Location "
                        }}</label>

                        <model-list-select
                          :isDisabled="disbleEnquiry"
                          @input="
                            getLocationList(
                              $event,
                              'Icd,Sea_Port_India',
                              'handoverListData'
                            )
                          "
                          @searchchange="
                            getLocationList(
                              $event,
                              'Icd,Sea_Port_India',
                              'handoverListData'
                            )
                          "
                          :list="handoverListData"
                          v-model="ffExoprtDetail.handoverLocationId"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          placeholder="Select Handover Location"
                        ></model-list-select>

                        <span class="error" v-if="!ffExoprtDetail.handoverLocationId">{{
                          handoverLocationIdError
                        }}</span>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter v-if="hideTPTSection == false">
                      <md-layout
                        md-flex="50"
                        class="pr-2 pl-2"
                        v-if="
                          hideTPTSection == false && ffExoprtDetail.shipmentType == '1'
                        "
                        md-flex-small="100"
                      >
                        <label for="AutoStuffingLocation">{{
                          newJobType.indexOf("TPT") >= 0
                            ? "Factory Location *"
                            : "Factory Location "
                        }}</label>

                        <!-- :list="factoryDetail" -->
                        <!-- :isDisabled="ffExoprtDetail.clientId==''?true:false" 
                        option-value="location"
                        option-text="factoryTitle"-->
                        <!-- @input="getLocationList($event,'Client_Factory','getAlllocationListDataFactory')"
                        @searchchange="getLocationList($event,'Client_Factory','getAlllocationListDataFactory')"-->
                        <model-list-select
                          id="down2"
                          @input="
                            getLocationList(
                              $event,
                              'Client_Factory',
                              'getAlllocationListDataFactory'
                            );
                            ffExoprtDetail.shipmentType == '1' &&
                            ffExoprtDetail.transportType == 'Export' &&
                            ffExoprtDetail.multipleContainerType[0] == 'LCL Container' &&
                            newJobType.indexOf('TPT') >= 0
                              ? FactoryPickupSame(ffExoprtDetail.stuffingLocationId)
                              : '';
                          "
                          @searchchange="
                            getLocationList(
                              $event,
                              'Client_Factory',
                              'getAlllocationListDataFactory'
                            )
                          "
                          :isDisabled="disbleEnquiry"
                          :list="allLocationListFactory"
                          v-model="ffExoprtDetail.stuffingLocationId"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          :placeholder="
                            allLocationList.length > 0
                              ? 'Select Factory Location'
                              : 'No Factory'
                          "
                        ></model-list-select>

                        <span class="error" v-if="!ffExoprtDetail.stuffingLocationId">{{
                          stuffingLocationIdError
                        }}</span>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->

                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <label for="ccType">TPT Type</label>
                        <model-list-select
                          :isDisabled="disbleEnquiry"
                          :list="cctypeList"
                          v-model="ffExoprtDetail.tptType"
                          option-value="ccTypeVal"
                          option-text="ccTypeTxt"
                          placeholder="Select"
                        ></model-list-select>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout
                        md-flex="50"
                        class="pr-2 pl-2"
                        md-flex-small="100"
                        v-if="ffExoprtDetail.tptType == '2'"
                      >
                        <md-layout md-flex="100">
                          <label>Transporter Name</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            :disabled="disbleEnquiry"
                            id="transporterName"
                            name="transporterName"
                            v-model="ffExoprtDetail.transporterName"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter v-if="hideTPTSection == false">
                        <md-layout md-flex="100" md-flex-small="100" class="pr-2 pl-2">
                          <md-layout md-flex="100">
                            <label>ON ACCOUNT OF</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              :disabled="disbleEnquiry"
                              id="onAccountOf"
                              name="onAccountOf"
                              v-model="ffExoprtDetail.onAccountOf"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                    <!-- <md-layout md-gutter  >
               
           
                    <md-layout md-flex="40" v-if="hideTPTSection==false"  >
                    <label for="containerTypeId">Container Type/Size (Transportation)</label>
                    <model-list-select
                    :list="ContainerTypeList"
                    v-model="ffExoprtDetail.transContainerTypeId"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type/Size"
                    ></model-list-select>
                    <span
                    class="error"
                    v-if="!ffExoprtDetail.transContainerTypeId"
                    >{{transContainerTypeIdError}}</span>
                    yout>
                    </md-layout>-->
                  </div>
                </b-collapse>
              </div>
              <!--<h5>   <b-badge class="mt-3" block v-b-toggle.accordion-2 variant="info">Freight & Custom</b-badge></h5> -->
              <b-collapse
                :visible="ffExoprtDetail.mainEnquiryId != '' ? true : showFFCCAccordina"
                id="accordion-2"
                accordion="my-accordion2"
                role="tabpanel"
              >
                <div>
                  <div>
                    <md-layout md-gutter>
                      <md-layout md-flex="25" class="pr-2 pl-2" md-flex-small="100">
                        <label for="ffAc">{{
                          newJobType.indexOf("CC") >= 0 || newJobType.indexOf("FF") >= 0
                            ? "FF Activity Type *"
                            : "FF Activity Type"
                        }}</label>

                        <model-list-select
                          :isDisabled="
                            disbleEnquiry ||
                            (ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export' &&
                              ffExoprtDetail.multipleContainerType[0] == 'LCL Container')
                          "
                          :list="
                            ffExoprtDetail.shipmentType == '1'
                              ? containerInfoName
                              : ffActivityAir
                          "
                          v-model="ffExoprtDetail.containerInfo"
                          option-value="containerInfoVal"
                          option-text="containerInfoText"
                          placeholder="Select Activity Type"
                        ></model-list-select>
                        <!-- &&
                              newJobType.indexOf('TPT') >= 0 -->
                        <span class="error" v-if="!ffExoprtDetail.containerInfo">{{
                          containerInfoError
                        }}</span>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout md-flex="25" class="pl-2 pr-2" md-flex-small="100">
                        <label>Estimated Date *</label>
                        <md-layout md-flex="100" md-flex-small="100">
                          <date-picker
                            width="100%"
                            :disabled="disbleEnquiry"
                            :format="selectDateFormat"
                            lang="en"
                            name="weighingDate"
                            id="weighingDate"
                            v-model="ffExoprtDetail.estimatedDate"
                          ></date-picker>
                        </md-layout>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->

                      <md-layout
                        md-flex="50"
                        class="pr-2 pl-2"
                        md-flex-small="100"
                        v-if="ffExoprtDetail.shipmentType == '1'"
                      >
                        <label for="stuffingType">{{
                          newJobType.indexOf("CC") >= 0 || newJobType.indexOf("FF") >= 0
                            ? "Stuffing Type *"
                            : "Stuffing Type"
                        }}</label>

                        <!-- :isDisabled="ffExoprtDetail.containerInfo!='fcl'?true:false" -->
                        <model-list-select
                          :isDisabled="
                            ffExoprtDetail.containerInfo == 'lcl' || disbleEnquiry
                              ? true
                              : false
                          "
                          :list="stuffingTypeName"
                          v-model="ffExoprtDetail.stuffingType"
                          option-value="stuffingTypeVal"
                          option-text="stuffingTypeText"
                          placeholder="Select Stuffing Type"
                        ></model-list-select>
                        <span class="error" v-if="!ffExoprtDetail.stuffingType">{{
                          stuffingTypeError
                        }}</span>
                      </md-layout>
                      <!-- </md-layout> -->

                      <!-- <md-layout md-gutter > -->

                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <label for="ffssd">{{
                          newJobType.indexOf("CC") >= 0 || newJobType.indexOf("FF") >= 0
                            ? "Importer Name *"
                            : "Importer Name"
                        }}</label>

                        <model-list-select
                          :isDisabled="
                            ffExoprtDetail.transportType == 'Import' || disbleEnquiry
                              ? true
                              : false
                          "
                          :list="getImporterExpo"
                          id="clientNamenew"
                          @input="showExpInput"
                          v-model="ffExoprtDetail.importerClientId"
                          option-value="clientId"
                          option-text="clientName"
                          placeholder="Select Importer Name"
                        ></model-list-select>
                        <span class="error" v-if="!ffExoprtDetail.importerClientId">{{
                          importerClientIdError
                        }}</span>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <label for="ffssxzxd">{{
                          newJobType.indexOf("CC") >= 0 || newJobType.indexOf("FF") >= 0
                            ? "Exporter Name *"
                            : "Exporter Name"
                        }}</label>

                        <!-- {{ ffExoprtDetail }} -->

                        <model-list-select
                          v-if="
                            (ffExoprtDetail.transportType == 'Export' ||
                              ffExoprtDetail.transportType == 'Import') &&
                            (ffExoprtDetail.clientType == '2' ||
                              ffExoprtDetail.clientType == '3' ||
                              ffExoprtDetail.clientType == '4')
                          "
                          :isDisabled="
                            (ffExoprtDetail.transportType == 'Export' &&
                              ffExoprtDetail.clientType == '2') ||
                            disbleEnquiry
                              ? true
                              : false
                          "
                          class="ml-1"
                          :list="
                            ffExoprtDetail.clientType == '2'
                              ? $store.getters['common/getAllLeadCompList']
                              : (ffExoprtDetail.clientType == '3'||ffExoprtDetail.clientType == '4')
                              ? getCLientData
                              : $store.getters['common/getAllClientList']
                          "
                          @input="pickUpExpClient($event);showExpInput"
                          id="clientNamenew"
                          v-model="ffExoprtDetail.exporterClientId"
                          
                          :option-value="
                            ffExoprtDetail.clientType == '2' ? 'lead_id' : 'clientId'
                          "
                          :option-text="
                            ffExoprtDetail.clientType == '2'
                              ? 'lead_comp_name'
                              : 'clientName'
                          "
                          placeholder="Select Exporter Name"
                        ></model-list-select>
                        <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{
                          exporterClientIdError
                        }}</span>

                        <model-list-select
                          v-if="
                            (ffExoprtDetail.transportType == 'Export' ||
                              ffExoprtDetail.transportType == 'Import') &&
                            ffExoprtDetail.clientType == '1'
                          "
                          :isDisabled="
                            (ffExoprtDetail.transportType == 'Export' &&
                              ffExoprtDetail.clientType == '1') ||
                            disbleEnquiry
                              ? true
                              : false
                          "
                          :list="getImporterExpo"
                          id="clientNamenew"
                          v-model="ffExoprtDetail.exporterClientId"
                          option-value="clientId"
                          option-text="clientName"
                          placeholder="Select Exporter Name"
                        ></model-list-select>
                        <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{
                          exporterClientIdError
                        }}</span>
                      </md-layout>
                      <!-- </md-layout> -->
                      <!-- <md-layout md-gutter > -->

                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <label v-if="openImpoInput == true" for="clientId"
                          >Importer Name</label
                        >

                        <b-form-input
                          :formatter="capitalizeAll"
                          :disabled="disbleEnquiry"
                          v-if="openImpoInput == true"
                          id="otherImpoName"
                          name="otherImpoName"
                          v-model="ffExoprtDetail.otherImpoName"
                        ></b-form-input>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout
                        md-flex="50"
                        class="pr-2 pl-2"
                        md-flex-small="100"
                        v-if="openExpoInput == true"
                      >
                        <label for="clientId">Exporter Name</label>

                        <b-form-input
                          :formatter="capitalizeAll"
                          :disabled="disbleEnquiry"
                          id="otherExpoName"
                          name="otherExpoName"
                          v-model="ffExoprtDetail.otherExpoName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>

                    <div>
                      <md-layout md-gutter>
                        <md-layout
                          md-flex="50"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="
                            (ffExoprtDetail.transportType == 'Import' ||
                              ffExoprtDetail.shipmentType == '1') &&
                            hideCCSection == false &&
                            ffExoprtDetail.PORFromTPT != ''
                          "
                        >
                          <label for="ffscxcsxzxd">{{
                            newJobType.indexOf("CC") >= 0 || newJobType.indexOf("FF") >= 0
                              ? "Place of Receipt *"
                              : "Place of Receipt"
                          }}</label>

                          <b-form-input
                            :formatter="capitalizeAll"
                            disabled
                            v-model="ffExoprtDetail.PORFromTPT"
                            name="PORFromTPT"
                            id="PORFromTPT"
                          ></b-form-input>
                        </md-layout>
                        <md-layout
                          md-flex="50"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="
                            (ffExoprtDetail.transportType == 'Import' ||
                              ffExoprtDetail.shipmentType == '1') &&
                            hideCCSection == false &&
                            ffExoprtDetail.PORFromTPT == ''
                          "
                        >
                          <label for="ffscxcsxzxd">{{
                            newJobType.indexOf("CC") >= 0 || newJobType.indexOf("FF") >= 0
                              ? "Place of Receipt *"
                              : "Place of Receipt"
                          }}</label>
                          <model-list-select
                            :isDisabled="
                              disbleEnquiry ||
                              ffExoprtDetail.shipmentType == '' ||
                              ffExoprtDetail.transportType == ''
                            "
                            @input="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Icd,Sea_Port_India'
                                  : 'Sea_Port_NonIndia',
                                'IcdPOrtList'
                              )
                            "
                            @searchchange="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Icd,Sea_Port_India'
                                  : 'Sea_Port_NonIndia',
                                'IcdPOrtList'
                              )
                            "
                            :list="IcdPOrtListNew"
                            v-model="ffExoprtDetail.PORlocationId"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Place of Receipt"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.PORlocationId">{{
                            PORlocationIdError
                          }}</span>
                        </md-layout>

                        <!-- <md-layout md-flex="5" v-if=" ffExoprtDetail.shipmentType=='1' "></md-layout> -->
                        <md-layout
                          :md-flex="hideCCSection == false ? '50' : '40'"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="
                            ffExoprtDetail.shipmentType == '1' && hideFFSection == false
                          "
                        >
                          <label for="ffscxcsxzxd">{{
                            newJobType.indexOf("FF") >= 0
                              ? "Load Port Name *"
                              : "Load Port Name"
                          }}</label>

                          <model-list-select
                            :isDisabled="
                              disbleEnquiry ||
                              ffExoprtDetail.shipmentType == '' ||
                              ffExoprtDetail.transportType == '' ||
                              ffExoprtDetail.multipleContainerType.length == 0
                            "
                            @input="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Sea_Port_India'
                                  : 'Sea_Port_NonIndia',
                                'PortLoadList'
                              )
                            "
                            @searchchange="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Sea_Port_India'
                                  : 'Sea_Port_NonIndia',
                                'PortLoadList'
                              )
                            "
                            :list="PortLoadList"
                            v-model="ffExoprtDetail.LPlocationId"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Load Port Name"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.LPlocationId">{{
                            LPlocationIdError
                          }}</span>
                        </md-layout>
                      </md-layout>
                      <!-- v-if="hideCCSection==false" -->
                      <md-layout md-gutter>
                        <md-layout
                          md-flex="50"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="
                            ffExoprtDetail.shipmentType == '1' && hideFFSection == false
                          "
                        >
                          <label for="ffscxcsxzxd">{{
                            newJobType.indexOf("FF") >= 0
                              ? "Port of Discharge *"
                              : "Port of Discharge"
                          }}</label>

                          <model-list-select
                            :isDisabled="
                              disbleEnquiry ||
                              ffExoprtDetail.shipmentType == '' ||
                              ffExoprtDetail.transportType == '' ||
                              ffExoprtDetail.multipleContainerType.length == 0
                            "
                            @input="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Sea_Port_NonIndia'
                                  : 'Sea_Port_India',
                                'getPortDischargeList'
                              )
                            "
                            @searchchange="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Sea_Port_NonIndia'
                                  : 'Icd,Sea_Port_India',
                                'getPortDischargeList'
                              )
                            "
                            :list="PortDischargeList"
                            v-model="ffExoprtDetail.PODLocationId"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select POD"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.PODLocationId">{{
                            PODLocationIdError
                          }}</span>
                        </md-layout>
                        <!-- <md-layout md-flex="5" ></md-layout> -->
                        <md-layout
                          md-flex="50"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="
                            (ffExoprtDetail.transportType == 'Import' ||
                              ffExoprtDetail.shipmentType == '1') &&
                            hideFFSection == false
                          "
                        >
                          <label for="ffscxcsxzxd">{{
                            newJobType.indexOf("FF") >= 0
                              ? "Final Place of Delivery *"
                              : "Final Place of Delivery"
                          }}</label>

                          <model-list-select
                            :isDisabled="
                              disbleEnquiry ||
                              ffExoprtDetail.shipmentType == '' ||
                              ffExoprtDetail.transportType == ''
                            "
                            @input="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Sea_Port_NonIndia'
                                  : 'Icd,Sea_Port_India',
                                'finalAllPlaceData'
                              )
                            "
                            @searchchange="
                              getLocationList(
                                $event,
                                ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export'
                                  ? 'Sea_Port_NonIndia'
                                  : 'Icd,Sea_Port_India',
                                'finalAllPlaceData'
                              )
                            "
                            :list="finalAllPlaceData"
                            v-model="ffExoprtDetail.finalPlaceLocationId"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select FPOD"
                          ></model-list-select>
                          <span
                            class="error"
                            v-if="!ffExoprtDetail.finalPlaceLocationId"
                            >{{ finalPlaceLocationIdError }}</span
                          >
                        </md-layout>
                      </md-layout>
                      <md-layout
                        md-gutter
                        v-if="
                          ffExoprtDetail.shipmentType == '1' && hideFFSection == false
                        "
                      >
                        <md-layout
                          md-flex="50"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="ffExoprtDetail.shipmentType == '1'"
                        >
                          <label for="shippingId">Shipping Line Name (Prefered)</label>
                          <!-- {{ffExoprtDetail.multipleContainerType[0]}} -->
                          <!-- {{ffExoprtDetail}} -->
                          <!-- ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export' &&
                              ffExoprtDetail.multipleContainerType[0] ==
                                'LCL Container' &&
                              newJobType.indexOf('TPT') >= 0 &&
                              ffExoprtDetail.containerInfo == 'lcl' -->
                          <!-- (ffExoprtDetail.shipmentType == '1' &&
                                ffExoprtDetail.transportType == 'Export' &&
                                ffExoprtDetail.multipleContainerType[0] ==
                                  'LCL Container' &&
                                newJobType.indexOf('TPT') >= 0 &&
                                ffExoprtDetail.containerInfo == 'lcl') -->
                          <!-- {{this.ffExoprtDetail}} -->
                          <model-list-select
                            v-if="
                              ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export' &&
                              ffExoprtDetail.multipleContainerType[0] ==
                                'LCL Container' &&
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                            :isDisabled="
                              disbleEnquiry ||
                              !(
                                ffExoprtDetail.shipmentType == '1' &&
                                ffExoprtDetail.transportType == 'Export' &&
                                ffExoprtDetail.multipleContainerType[0] ==
                                  'LCL Container' &&
                                ffExoprtDetail.containerInfo == 'lcl'
                              )
                                ? true
                                : false
                            "
                            :list="getColoaderNameList"
                            v-model="ffExoprtDetail.shippingId"
                            option-value="agntColoaderId"
                            option-text="coLoaderName"
                            placeholder="Select Shipping Line"
                          ></model-list-select>
                          <model-list-select
                            v-else
                            :isDisabled="disbleEnquiry"
                            :list="getShippingLineData"
                            v-model="ffExoprtDetail.shippingId"
                            option-value="shippingId"
                            option-text="shippingLine"
                            placeholder="Select Shipping Line"
                          ></model-list-select>
                          <!-- <span class="error" v-if="!ffExoprtDetail.shippingId">{{shippingIdError}}</span> -->
                        </md-layout>
                        <!-- <md-layout md-flex="5"></md-layout> -->
                        <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                          <label for="deliveryMode">Destination Delivery Mode</label>
                          <model-list-select
                            :isDisabled="disbleEnquiry"
                            :list="deliveryModeName"
                            v-model="ffExoprtDetail.deliveryMode"
                            option-value="deliveryModeVal"
                            option-text="deliveryModeText"
                            placeholder="Select  Mode"
                          ></model-list-select>
                        </md-layout>
                        <!-- <md-layout md-flex="5"></md-layout> -->

                        <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                          <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                          <model-list-select
                            :isDisabled="disbleEnquiry"
                            :list="deliveryTermsName"
                            v-model="ffExoprtDetail.deliveryTerms"
                            option-value="deliveryTermsVal"
                            option-text="deliveryTermsText"
                            placeholder="Select Delivery Terms"
                          ></model-list-select>
                        </md-layout>
                      </md-layout>
                    </div>

                    <div>
                      <md-layout
                        md-gutter
                        v-if="
                          ffExoprtDetail.shipmentType == '2' && hideFFSection == false
                        "
                      >
                        <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                          <label for="PORlocationId"
                            >Airport of Departure (Handover)</label
                          >
                          <model-list-select
                            :isDisabled="disbleEnquiry"
                            @input="getLocationList($event, 'Air_Port', 'AirIcdPOrtList')"
                            @searchchange="
                              getLocationList($event, 'Air_Port', 'AirIcdPOrtList')
                            "
                            :list="AirIcdPOrtList"
                            v-model="ffExoprtDetail.airportDeparture"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Airport Departure"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.airportDeparture">{{
                            airportDepartureError
                          }}</span>
                        </md-layout>

                        <!-- <md-layout md-flex="5"></md-layout> -->
                        <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                          <label for="LPlocationId">Airport of Destination</label>
                          <model-list-select
                            :isDisabled="disbleEnquiry"
                            @input="
                              getLocationList($event, 'Air_Port', 'AirPortLoadList')
                            "
                            @searchchange="
                              getLocationList($event, 'Air_Port', 'AirPortLoadList')
                            "
                            :list="AirPortLoadList"
                            v-model="ffExoprtDetail.airportDestination"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Destination"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.airportDestination">{{
                            airportDestinationError
                          }}</span>
                        </md-layout>
                      </md-layout>
                      <div>
                        <md-layout md-gutter>
                          <md-layout
                            md-flex="50"
                            class="pr-2 pl-2"
                            v-if="ffExoprtDetail.shipmentType == '2'"
                            md-flex-small="100"
                          >
                            <label for="containerTypeId">Airline (Prefered)</label>
                            <model-list-select
                              :isDisabled="disbleEnquiry"
                              :list="airLineList"
                              v-model="ffExoprtDetail.airlineId"
                              option-value="airlineId"
                              option-text="airlineName"
                              placeholder="Select Airline"
                            ></model-list-select>
                            <!-- <span
                            class="error"
                            v-if="!ffExoprtDetail.transContainerTypeId"
                            >{{transContainerTypeIdError}}</span>-->
                          </md-layout>

                          <md-layout
                            md-flex="5"
                            v-if="
                              ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                          ></md-layout>
                          <md-layout
                            md-flex="25"
                            v-if="
                              ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                          >
                            <label for="agentName">CoLoader Name</label>
                            <!-- !(ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export' &&
                                  ffExoprtDetail.multipleContainerType[0] ==
                                    'LCL Container' &&
                                  newJobType.indexOf('TPT') >= 0 &&
                                  ffExoprtDetail.containerInfo == 'lcl') -->
                            <model-list-select
                              :list="getColoaderNameList"
                              :isDisabled="
                                disbleEnquiry ||
                                !(
                                  ffExoprtDetail.shipmentType == '1' &&
                                  ffExoprtDetail.transportType == 'Export' &&
                                  ffExoprtDetail.multipleContainerType[0] ==
                                    'LCL Container' &&
                                  ffExoprtDetail.containerInfo == 'lcl'
                                )
                                  ? true
                                  : false
                              "
                              v-model="ffExoprtDetail.coLoaderId"
                              option-value="agntColoaderId"
                              option-text="coLoaderName"
                              placeholder="Select Coloader Name"
                              @input="
                                ColoderBasedShipppingLine(ffExoprtDetail.coLoaderId)
                              "
                            ></model-list-select>
                          </md-layout>
                          <!-- <md-layout md-flex="5"></md-layout> -->

                          <md-layout
                            md-flex="15"
                            class="pr-2 pl-2"
                            v-if="
                              ffExoprtDetail.shipmentType == '2' ||
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                            md-flex-small="100"
                          >
                            <md-layout md-flex="100">
                              <label for="noOfPkg">No. of Packages</label>

                              <b-form-input
                                :formatter="capitalizeAll"
                                :disabled="disbleEnquiry"
                                id="noOfPkg"
                                name="noOfPkg"
                                type="number"
                                v-model="ffExoprtDetail.noOfPkg"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                          <md-layout
                            md-flex="5"
                            v-if="
                              ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                          ></md-layout>
                          <md-layout
                            md-flex="10"
                            v-if="
                              ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                          >
                            <div class="row mt-3" style="display: none">
                              <b-form-radio
                                :disabled="disbleEnquiry"
                                v-model="ffExoprtDetail.selectedDimmen"
                                name="some-radios"
                                value="Same"
                                >Same Dimension</b-form-radio
                              >
                              <b-form-radio
                                :disabled="disbleEnquiry"
                                v-model="ffExoprtDetail.selectedDimmen"
                                name="some-radios"
                                value="Different"
                                >Different</b-form-radio
                              >
                            </div>
                          </md-layout>
                          <!-- <md-layout md-flex="5"></md-layout> -->

                          <md-layout
                            md-flex="15"
                            class="pl-2 pr-2"
                            v-if="
                              ffExoprtDetail.shipmentType == '2' ||
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                            md-flex-small="100"
                          >
                            <md-layout md-flex="100">
                              <label for="noOfPkg">Gross Wgt(Kg)</label>

                              <b-form-input
                                :formatter="capitalizeAll"
                                :disabled="disbleEnquiry"
                                id="noOfPkg"
                                name="noOfPkg"
                                type="number"
                                v-model="ffExoprtDetail.lclGrossWgt"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                          <!-- <md-layout md-flex="5"></md-layout> -->
                          <md-layout
                            md-flex="20"
                            class="pr-2 pl-2"
                            v-if="
                              ffExoprtDetail.shipmentType == '2' ||
                              ffExoprtDetail.containerInfo == 'lcl'
                            "
                            md-flex-small="100"
                          >
                            <md-layout md-flex="100">
                              <label for="grossVolWgt">{{
                                ffExoprtDetail.shipmentType == "1"
                                  ? " Vol. Wgt.(In CBM)"
                                  : "Gross Volume Wgt."
                              }}</label>

                              <b-form-input
                                :formatter="capitalizeAll"
                                :disabled="disbleEnquiry"
                                id="grossVolWgt"
                                name="grossVolWgt"
                                type="number"
                                v-model="ffExoprtDetail.grossVolWgtAir"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                        </md-layout>

                        <md-layout
                          md-gutter
                          v-if="
                            ffExoprtDetail.shipmentType == '1' &&
                            ffExoprtDetail.containerInfo == 'lcl'
                          "
                        >
                          <md-layout md-flex="30" md-flex-small="100">
                            <md-layout md-flex="100">
                              <label for="noOfPkg">Net Wt ( in KG)</label>

                              <b-form-input
                                :formatter="capitalizeAll"
                                :disabled="disbleEnquiry"
                                id="noOfPkg"
                                name="noOfPkg"
                                type="number"
                                v-model="ffExoprtDetail.lclNetWgt"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                        </md-layout>
                      </div>

                      <md-layout md-gutter v-if="ffExoprtDetail.shipmentType == '2'">
                        <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                          <label for="PORlocationId">Cargo Received At</label>
                          <model-list-select
                            :disabled="disbleEnquiry"
                            :list="cargoReceivedList"
                            v-model="ffExoprtDetail.cargoReceived"
                            option-value="val"
                            option-text="type"
                            placeholder="Select Cargo Received"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.cargoReceived">{{
                            cargoReceivedError
                          }}</span>
                        </md-layout>

                        <!-- <md-layout md-flex="5"></md-layout> -->
                        <md-layout md-flex="20" class="pl-2 pr-2" md-flex-small="100">
                          <label for="LPlocationId">Destination Delivery Mode</label>
                          <model-list-select
                            :isDisabled="disbleEnquiry"
                            :list="destinationDelieveryList"
                            v-model="ffExoprtDetail.destinationModeAir"
                            option-value="val"
                            option-text="type"
                            placeholder="Select Destination"
                          ></model-list-select>
                          <span class="error" v-if="!ffExoprtDetail.destinationModeAir">{{
                            destinationModeAirError
                          }}</span>
                        </md-layout>

                        <!-- <md-layout md-flex="5"></md-layout> -->

                        <md-layout
                          md-flex="30"
                          class="pr-2 pl-2"
                          md-flex-small="100"
                          v-if="ffExoprtDetail.destinationModeAir == '2'"
                        >
                          <label for="LPlocationId">FPOD</label>
                          <model-list-select
                            :isDisabled="disbleEnquiry"
                            @input="getLocationList($event, 'All', 'finalAllPlaceData')"
                            @searchchange="
                              getLocationList($event, 'All', 'finalAllPlaceData')
                            "
                            :list="finalAllPlaceData"
                            v-model="ffExoprtDetail.doorDestinationfpod"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Destination"
                          ></model-list-select>
                        </md-layout>
                      </md-layout>
                    </div>

                    <md-layout
                      md-gutter
                      v-if="
                        ffExoprtDetail.selectedCCQuotationId == '' &&
                        ffExoprtDetail.shipmentType == '1'
                      "
                    >
                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <label for="ccType">CC Type</label>
                        <model-list-select
                          :isDisabled="disbleEnquiry"
                          :list="cctypeList"
                          v-model="ffExoprtDetail.ccType"
                          option-value="ccTypeVal"
                          option-text="ccTypeTxt"
                          placeholder="Select CC Type"
                        ></model-list-select>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout
                        md-flex="50"
                        class="pr-2 pl-2"
                        md-flex-small="100"
                        v-if="ffExoprtDetail.ccType == '2'"
                      >
                        <md-layout md-flex="100">
                          <label>CHA Name</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="ccCha"
                            :disabled="disbleEnquiry"
                            name="ccCha"
                            v-model="ffExoprtDetail.ccCha"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <!-- <md-layout md-gutter  >
                 
                    <md-layout md-flex="90" md-flex-small="100">
                      <md-layout md-flex="100">
                        <label>OtherDetails</label>
                        <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark" v-model="ffExoprtDetail.othersLocDetails"></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    </md-layout>-->
                    <md-layout md-gutter>
                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <md-layout md-flex="100">
                          <label for="otherComodity">Commodity Details</label>

                          <b-form-textarea
                            :formatter="capitalizeAll"
                            :disabled="disbleEnquiry"
                            id="otherComodity"
                            name="otherComodity"
                            v-model="ffExoprtDetail.otherComodity"
                          ></b-form-textarea>
                        </md-layout>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout> -->
                      <md-layout md-flex="50" class="pr-2 pl-2" md-flex-small="100">
                        <md-layout md-flex="100">
                          <label>Remarks</label>
                          <b-form-textarea
                            :formatter="capitalizeAll"
                            id="remark"
                            name="remark"
                            v-model="ffExoprtDetail.remark"
                          ></b-form-textarea>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                  </div>
                </div>
              </b-collapse>

              <hr
                class="hr-s"
                v-if="
                  ffExoprtDetail.tptEnquiry.length > 0 ||
                  ffExoprtDetail.ffEnquiry.length > 0 ||
                  ffExoprtDetail.ccEnquiry.length > 0
                "
              />
              <!-- {{ffExoprtDetail}} -->
              <md-layout md-gutter v-if="ffExoprtDetail.tptEnquiry.length > 0">
                <!-- {{ffExoprtDetail}} -->
                <md-layout
                  md-flex="50"
                  md-flex-small="100"
                  v-if="ffExoprtDetail.tptEnquiry[0].tptStatus == 1"
                >
                  <label for="transportType">Client Approval (TPT)</label>
                  <model-list-select
                    :list="statusList"
                    v-model="ffExoprtDetail.tptClientStatus"
                    option-value="statusV"
                    option-text="statusT"
                    placeholder="Select Status"
                    :isDisabled="ffExoprtDetail.tptStatus == '0' ? false : true"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="ffExoprtDetail.ccEnquiry.length > 0">
                <!-- v-if="ffExoprtDetail.ccStatus==1" -->
                <md-layout
                  md-flex="50"
                  md-flex-small="100"
                  v-if="ffExoprtDetail.ccEnquiry[0].ccStatus == 1"
                >
                  <label for="transportType">Client Approval (CC)</label>
                  <model-list-select
                    :list="statusList"
                    v-model="ffExoprtDetail.ccClientStatus"
                    option-value="statusV"
                    option-text="statusT"
                    placeholder="Select Status"
                    :isDisabled="ffExoprtDetail.ccStatus == '0' ? false : true"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="ffExoprtDetail.ffEnquiry.length > 0">
                <md-layout
                  md-flex="50"
                  md-flex-small="100"
                  v-if="ffExoprtDetail.ffEnquiry[0].ffStatusManager == 1"
                >
                  <label for="transportType">Client Approval (FF)</label>
                  <model-list-select
                    :list="statusList"
                    v-model="ffExoprtDetail.ffClientStatus"
                    option-value="statusV"
                    option-text="statusT"
                    placeholder="Select Status"
                    :isDisabled="ffExoprtDetail.ffStatus == '0' ? false : true"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout
                  md-flex="45"
                  md-flex-small="100"
                  v-if="ffExoprtDetail.ffClientStatus == '1'"
                >
                  <label for="ffShippingWiseId"
                    >Approved
                    {{
                      ffExoprtDetail.shipmentType == "1" &&
                      ffExoprtDetail.containerInfo == "lcl"
                        ? "Co Loader"
                        : ffExoprtDetail.shipmentType == "1"
                        ? "Shipping Line"
                        : "Airline"
                    }}
                    By Client</label
                  >
                  <model-list-select
                    :list="ffShippingArray"
                    v-model="ffExoprtDetail.ffShippingWiseId"
                    option-value="ffShippingWiseId"
                    :option-text="
                      ffExoprtDetail.shipmentType == '1' &&
                      ffExoprtDetail.containerInfo == 'lcl'
                        ? 'coLoaderName'
                        : ffExoprtDetail.shipmentType == '1'
                        ? 'shippingLine'
                        : 'airlineName'
                    "
                    :placeholder="
                      ffExoprtDetail.shipmentType == '1' &&
                      ffExoprtDetail.containerInfo == 'lcl'
                        ? 'Select Coloader'
                        : ffExoprtDetail.shipmentType == '1'
                        ? 'shippingLine'
                        : ' Select Airline'
                    "
                    :isDisabled="ffExoprtDetail.ffStatus == '0' ? false : true"
                  ></model-list-select>
                </md-layout>
              </md-layout>

              <md-layout
                md-flex-small="100"
                md-gutter
                class="justify-content-center mt-3"
                v-if="allModuleIdNew == '' || allModuleIdNew == null"
              >
                <!-- style="position: fixed;z-index:9999;
                top:17%;"-->
                <b-button variant="primary" id="addButtonLoader" @click="onCloseSubmit"
                  >Save & Submit</b-button
                >
                <b-button
                  v-if="showQuoteButton == true"
                  size="sm"
                  variant="warning"
                  @click="showExistQuote"
                  >Show Existing Quotes</b-button
                >

                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>

              <b-col lg="12">
                <span class="error pull-right" v-if="ffExoprtDetail.EnquiryCreated">
                  <b> {{ ffExoprtDetail.EnquiryCreated }}</b>
                </span>
              </b-col>

              <b-col lg="12">
                <span class="error pull-right" v-if="ffExoprtDetail.EnquiryUpdated">
                  <b> {{ ffExoprtDetail.EnquiryUpdated }}</b>
                </span>
              </b-col>

              <!-- <b-col lg="12"> {{ ffExoprtDetail }} </b-col> -->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <div>
      <b-modal
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        scrollable
        id="myDIV"
        hide-footer
        ref="QuotePop"
        title="Valid Existing Quotations"
      >
        <div class="d-block text-center">
          <b-card>
            <b-card-text>
              <div>
                <div>
                  <b-button
                    size="sm"
                    class="pull-right"
                    variant="outline-danger"
                    @click="closeDialogQuote"
                    >Cancel & Close</b-button
                  >
                  <b-button
                    size="sm"
                    class="pull-right"
                    style="margin:left:5px"
                    variant="outline-primary"
                    @click="closeDialogQuoteSave"
                    >Save</b-button
                  >
                </div>
                <b-tabs content-class="mt-3">
                  <b-tab disabled></b-tab>
                  <!-- <b-tab title="Test">
                    <div class="row"  v-if="newJobType.indexOf('FF')>=0 && allFFDataTable.length>0">
                      <div
                         v-for="(item1,index) in allFFDataTable"
                            :key="index"
                        class="col-md-4"
                       
                      >
                        <b-list-group>
                          <b-list-group-item active class="flex-column align-items-start">
                                <b-badge
                              class="quotePMargin"
                              variant="warning"
                              v-if="item1.ffvalidityDate < item1.currDate"
                            >Quote Expired</b-badge>
                            <div class="d-flex w-100 justify-content-between">
                              <h6 class="mb-1">
                                <b>{{item1.mainFFSeries}}</b>
                              </h6>
                              <small class="text-muted">
                                
                                <b style="color:white"> Validity {{item1.ffvalidityDate | moment}}</b>
                              </small>
                            </div>
                          </b-list-group-item>

                          <b-list-group-item
                         
                            class="align-items-start "
                          >
                        

                            <p
                              class="quotePMargin d-flex w-100 justify-content-between"
                            >FF Type : {{item1.transportType}}</p>
                            <div
                              class="quotePMargin "
                              v-if="ffExoprtDetail.shipmentType=='1'"
                            >
                              <p class="quotePMargin d-flex w-100 justify-content-between">
                                Shipping Line :
                                {{item1.ApprovedSLine}}
                              </p>

                              <p class="quotePMargin d-flex w-100 justify-content-between">
                                Place of Receipt :
                                {{item1.POR}}
                              </p>
                              <p class="quotePMargin d-flex w-100 justify-content-between ">
                                Load Port :
                                {{item1.LP}}
                              </p>
                              <p
                                class="quotePMargin pull-left"
                              >Port of Discharge : {{item1.POD}}</p>

                              <p
                                class="quotePMargin justify-content-between "
                              >Final Place of Delivery : {{item1.finalPlace}}</p>
                            </div>
                            <div v-else>
                              <p
                                class="quotePMargin d-flex w-100 justify-content-between "
                              >Departure Airport : {{item1.departPort}}</p>

                              <p
                                class="quotePMargin d-flex w-100 justify-content-between"
                              >Destination Airport : {{item1.destiPort}}</p>
                            </div>

                            <p
                              class="quotePMargin "
                              v-if="ffExoprtDetail.shipmentType=='1'"
                            >
                              Container Type /Size :
                              {{item1.multipleContainerType}}
                         
                            </p>

                        
  <div class="d-flex w-100 mt-2 justify-content-between">
                            <b-button
                              class="quotePMargin"
                              v-if="item1.ffQuotationPdf!='' && item1.ffQuotationPdf!=null"
                              size="sm"
                              variant="outline-success"
                              @click="PrintFF(item1.ffQuotationPdf)"
                            >
                              <md-icon>print</md-icon>
                            </b-button>

                            <md-radio
                              v-model="selectedFFRadio"
                              :id="item1.mainffId"
                              name="my-test-group2"
                              :md-value="item1.mainffId"
                              class="md-primary"
                              @change="selectedFFQuotation(item1.mainffId,item1.mainEnquiryId,item1)"
                            >Select</md-radio>

  </div>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </div>
                  </b-tab>-->
                  <b-tab
                    v-if="newJobType.indexOf('FF') >= 0 && allFFDataTable.length > 0"
                    title="Existing Freight Quotation"
                    active
                  >
                    <!-- <div>
                      <b-button
                        size="sm"
                        class="pull-right"
                        @click="clearFFRadio"
                        variant="outline-danger"
                      >Clear Selected</b-button>
                    </div>-->
                    <div
                      v-if="newJobType.indexOf('FF') >= 0 && allFFDataTable.length > 0"
                    >
                      <table id="FFTable" class="table gutr">
                        <thead>
                          <tr>
                            <th>Sr.No.</th>
                            <th>FF Quotation Details</th>
                            <th v-if="ffExoprtDetail.shipmentType == '1'">
                              Container Type
                            </th>
                            <th>Quotation No & Validity</th>
                            <th>Quote PDF</th>
                            <th>
                              <b-button size="sm" @click="clearFFRadio" variant="light"
                                >Clear Selected FF Quote</b-button
                              >
                            </th>

                            <!-- <th>Quotation Details</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index) in allFFDataTable" :key="index">
                            <td>{{ index + 1 }}</td>

                            <td>
                              <!-- <b>Quotation No :</b>
                      {{item1.ccQSeries}}
                              <br>-->
                              <b class="error">FF Type :</b>
                              <b class="error">{{ item1.transportType }}</b>
                              <div v-if="ffExoprtDetail.shipmentType == '1'">
                                <b>Shipping Line :</b>
                                {{ item1.ApprovedSLine }}
                                <br />

                                <b>Place of Receipt :</b>
                                {{ item1.POR }}
                                <br />
                                <b>Load Port :</b>
                                {{ item1.LP }}
                                <br />
                                <b>Port of Discharge :</b>
                                {{ item1.POD }}
                                <br />
                                <b>Final Place of Delivery :</b>
                                {{ item1.finalPlace }}
                              </div>
                              <div v-else>
                                <br />
                                <b>Departure Airport :</b>
                                {{ item1.departPort }}
                                <br />
                                <b>Destination Airport :</b>
                                {{ item1.destiPort }}
                              </div>
                            </td>
                            <td v-if="ffExoprtDetail.shipmentType == '1'">
                              <!-- <b>Container Type /Size :</b> -->
                              {{ item1.multipleContainerType }}
                              <!-- <br />
                      <b>No. of Containers :</b>
                              {{item1.noOfContainer}}-->
                            </td>
                            <td>
                              {{ item1.mainFFSeries }}
                              <br />
                              {{ item1.ffvalidityDate | moment }}
                              <br />
                              <b-badge
                                variant="success"
                                v-if="item1.ffvalidityDate < item1.currDate"
                                >Quote Expired</b-badge
                              >
                            </td>
                            <td>
                              <b-button
                                v-if="
                                  item1.ffQuotationPdf != '' &&
                                  item1.ffQuotationPdf != null
                                "
                                size="sm"
                                variant="outline-success"
                                @click="PrintFF(item1.ffQuotationPdf)"
                              >
                                <md-icon>print</md-icon>
                              </b-button>
                            </td>
                            <td>
                              <!-- <b-checkbox
                        id="flavors"
                        name="flavors"
                        class="ml-4"
                        @change="selectedFFQuotation(item1.mainffId,item1.mainEnquiryId,item1)"
                        aria-label="Individual flavours"
                        stacked
                              ></b-checkbox>-->
                              <md-radio
                                v-model="selectedFFRadio"
                                :id="item1.mainffId"
                                name="my-test-group2"
                                :md-value="item1.mainffId"
                                class="md-primary"
                                @change="
                                  selectedFFQuotation(
                                    item1.mainffId,
                                    item1.mainEnquiryId,
                                    item1
                                  )
                                "
                                >Select</md-radio
                              >
                              <!-- <b-radio
                          v-model="item1.mainffId"
                          name="radio-sizeFF"
                          size="lg"
                          @change="selectedFFQuotation(item1.mainffId,item1.mainEnquiryId,item1)"
                              >Select</b-radio>-->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>
                  <b-tab
                    v-if="newJobType.indexOf('CC') >= 0 && allCCDataTable.length > 0"
                    title="Existing Custom Quotation"
                  >
                    <div
                      class="box-body"
                      v-if="newJobType.indexOf('CC') >= 0 && allCCDataTable.length > 0"
                    >
                      <table id="CCTable" class="table">
                        <thead>
                          <tr>
                            <th>Sr.No.</th>
                            <th>CC Quotation Details</th>
                            <th>Container Type</th>
                            <th>Quote No. & Validity</th>
                            <th>Quote PDF</th>
                            <th>
                              <b-button
                                size="sm"
                                class="pull-right"
                                @click="clearCCRadio"
                                variant="light"
                                >Clear Selected CC Quote</b-button
                              >
                            </th>
                            <!-- <th>Quotation Details</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index) in allCCDataTable" :key="index">
                            <td>{{ index + 1 }}</td>

                            <td>
                              <!-- <b>Quotation No :</b>
                      {{item1.ccQSeries}}
                              <br>-->
                              <b class="error">CC Type :</b>
                              <b class="error">{{ item1.transportType }}</b>
                              <br />
                              <b>Place of Receipt :</b>
                              {{ item1.POR }}
                              <br />
                              <div v-if="item1.jobType.split(',').includes('FF')">
                                <b>Load Port :</b>
                                {{ item1.LP }}
                                <br />
                                <b>Port of Discharge :</b>
                                {{ item1.POD }}
                                <br />
                                <b>Final Place of Delivery :</b>
                                {{ item1.finalPlace }}
                              </div>
                            </td>
                            <td>
                              <!-- <b>Container Type /Size :</b> -->
                              {{ item1.multipleContainerType }}
                              <!-- <br />
                      <b>No. of Containers :</b>
                              {{item1.noOfContainer}}-->
                            </td>
                            <td>
                              {{ item1.ccQSeries }}
                              <br />
                              {{ item1.validityDate | moment }}
                              <br />
                              <b-badge
                                variant="success"
                                v-if="item1.validityDate < item1.currDate"
                                >Quote Expired</b-badge
                              >
                            </td>
                            <td>
                              <b-button
                                v-if="
                                  item1.ccQuotationPdf != '' &&
                                  item1.ccQuotationPdf != null
                                "
                                size="sm"
                                variant="outline-success"
                                @click="PrintCC(item1.ccQuotationPdf)"
                              >
                                <md-icon>print</md-icon>
                              </b-button>
                            </td>
                            <td>
                              <md-radio
                                v-model="selectedCCRadio"
                                :id="item1.ccQId"
                                name="my-test-group2"
                                :md-value="item1.ccQId"
                                class="md-primary"
                                @change="
                                  selectedCCQuotation(
                                    item1.ccQId,
                                    item1.mainEnquiryId,
                                    item1
                                  )
                                "
                                >Select</md-radio
                              >
                              <!-- <b-form-radio
                          id="CC"
                          name="radio-sizeCC"
                          @change="selectedCCQuotation(item1.ccQId,item1.mainEnquiryId)"
                          size="lg"
                              >Select</b-form-radio>-->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>
                  <b-tab
                    v-if="newJobType.indexOf('TPT') >= 0 && allTPTDataTable.length > 0"
                    title="Existing Transport Quotation"
                  >
                    <div
                      class="box-body"
                      v-if="newJobType.indexOf('TPT') >= 0 && allTPTDataTable.length > 0"
                    >
                      <table id="TPTTable" class="table">
                        <thead>
                          <tr>
                            <th>Sr.No.</th>
                            <th>TPT Quotation Details.</th>
                            <th>Container Type</th>
                            <th>Quotation No. & Validity</th>
                            <th>Quote PDF</th>
                            <th>
                              <b-button
                                size="sm"
                                class="pull-right"
                                @click="clearTPTRadio"
                                variant="light"
                                >Clear Selected TPT Quote</b-button
                              >
                            </th>
                            <!-- <th>Quotation Details</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index) in allTPTDataTable" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>
                              <!-- <b>Quotation No :</b>
                      {{item1.tptQSeries}}
                              <br>-->
                              <b class="error">TPT Type :</b>
                              <b class="error">{{ item1.transportType }}</b>
                              <br />
                              <b>Pickup :</b>
                              {{ item1.pickUp }}
                              <br />
                              <b>Factory :</b>
                              {{ item1.factoryLoc }}
                              <br />
                              <b>Handover :</b>
                              {{ item1.handover }}
                            </td>
                            <td>
                              <!-- <b>Container Type /Size :</b> -->
                              {{ item1.multipleContainerType }}
                              <!-- <br />
                      <b>No. of Containers :</b>
                              {{item1.noOfContainer}}-->
                            </td>
                            <td>
                              {{ item1.tptQSeries }}
                              <br />
                              {{ item1.validityDate | moment }}
                              <br />
                              <b-badge
                                variant="success"
                                v-if="item1.validityDate < item1.currDate"
                                >Quote Expired</b-badge
                              >
                            </td>
                            <td>
                              <b-button
                                v-if="
                                  item1.tptQuotationPdf != '' &&
                                  item1.tptQuotationPdf != null
                                "
                                size="sm"
                                variant="outline-success"
                                @click="PrintTPT(item1.tptQuotationPdf)"
                              >
                                <md-icon>print</md-icon>
                              </b-button>
                            </td>

                            <td>
                              <md-radio
                                v-model="selectedTPTRadio"
                                :id="item1.tptQId"
                                name="my-test-group2"
                                :md-value="item1.tptQId"
                                class="md-primary"
                                @change="
                                  selectedTPTQuotation(
                                    item1.tptQId,
                                    item1.mainEnquiryId,
                                    item1
                                  )
                                "
                                >Select</md-radio
                              >
                              <!-- <b-form-radio
                          name="radio-sizeTPT"
                          @change="selectedTPTQuotation(item1.tptQId,item1.mainEnquiryId)"
                          size="lg"
                              >Select</b-form-radio>-->
                            </td>
                            <!-- <td>
                    <b>Importer Name :</b>
                    {{item1.Importer}}
                    <br />
                    <b>Exporter Name :</b>
                    {{item1.Exporter}}
                            </td>-->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>

              <!-- FF Table -->
              <!-- CC Table  -->
              <!-- TPT Table -->
            </b-card-text>
          </b-card>
        </div>

        <div>
          <b-button
            size="sm"
            class="mt-3 pull-right"
            variant="outline-danger"
            @click="closeDialogQuote"
            >Cancel & Close</b-button
          >
          <b-button
            size="sm"
            class="mt-3 pull-right"
            style="margin:left:5px"
            variant="outline-primary"
            @click="closeDialogQuoteSave"
            >Save</b-button
          >
        </div>
      </b-modal>
    </div>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAddFF"
      ref="addPop"
    ></md-dialog-alert>
    <md-snackbar
      :md-position="vertical + ' ' + horizontal"
      ref="snackbar"
      :md-duration="duration"
    >
      <span>{{ snackbarData }}</span>
    </md-snackbar>
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="onCloseSubmit"
      ref="dialog5"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";

export default {
  beforeMount() {
    if (this.$sessionsStorage.get("userId") == "133") {
      this.$router.push({
        path: "/dashboard",
      });
    }
    this.$store.dispatch(
      "common/setAllLeadCompList",
      JSON.stringify({
        itemCode: "GET_LeadCompLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
        ClientType:"Client",
      })
    );
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/allModuleForm/allModuleForm");
      this.getServicesData();
      this.getData();
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    AutoContainerType: {
      handler: function (newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true,
    },
    // CommodityAll: {
    //   handler: function(newVal, oldVal) {
    //     this.CommodityCallback(newVal);
    //   },

    //   deep: true
    // },

    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        // if (this.ffExoprtDetail.finalPlaceLocationId != "") {

        // }
        console.log(this.newJobType);
        // 18-12-2024
        // if (
        //   (this.newJobType.includes("CC") || this.newJobType.includes("TPT")) &&
        //   this.ffExoprtDetail.shipmentType == "2"
        // ) {
        //   this.alert.content =
        //     "Custom and Transport are not applicable for Air shipments please uncheck CC and TPT";
        //   this.$refs["addPop22"].open();
        // }

        if (
          this.hideQuoteMode == false &&
          this.ffExoprtDetail.mainEnquiryId == "" &&
          this.ffExoprtDetail.shipmentType == "2"
        ) {
          if (this.newJobType.indexOf("FF") >= 0) {
            if (
              this.ffExoprtDetail.shipmentType != "" &&
              this.ffExoprtDetail.transportType != "" &&
              this.ffExoprtDetail.clientId != "" &&
              this.ffExoprtDetail.airportDeparture != "" &&
              this.ffExoprtDetail.airportDestination != ""
            ) {
              this.getAllQuotation();
            } else {
              console.log("Please Select all Fields To get Existing Quote ");
            }
          }
        }
        if (this.newJobType.indexOf("FF") < 0 && (this.ffExoprtDetail.clientType == "3"||this.ffExoprtDetail.clientType == "4")) {
          this.alert.content =
            `${this.ffExoprtDetail.clientType == "4"?'Consignee':'Overseas Agent'} Execution must include Freight Forwarding..!   Please Select Freight to continue`;
          this.$refs["addPop22"].open();
          this.ffExoprtDetail.clientType = "";
        }
        if (this.ffExoprtDetail.containerInfo == "lcl") {
          this.ffExoprtDetail.stuffingType = "warehouseStuffing";
        }

        if (this.ffExoprtDetail.clientId != "") {
          let facArry = this.tempfactoryDetail.filter((x) => {
            return x.clientId == this.ffExoprtDetail.clientId;
          });

          // if (facArry.length > 0) {

          //   this.getAlllocationListDataFactory.unshift(...facArry);
          // }

          if (
            this.ffExoprtDetail.transportType == "Export" &&
            (this.ffExoprtDetail.clientType != "3" && this.ffExoprtDetail.clientType != "4")
          ) {
            if(this.ffExoprtDetail.clientType != "3" && this.ffExoprtDetail.clientType != "4"){
            if (
              this.ffExoprtDetail.transportType == "Export" &&
              this.ffExoprtDetail.clientType == "2"
            ) {
              this.ffExoprtDetail.exporterClientId = this.ffExoprtDetail.fk_lead_id;
            } else {
              this.ffExoprtDetail.exporterClientId = this.ffExoprtDetail.clientId;
            }
          }
          } else if (
            this.ffExoprtDetail.transportType == "Import" &&
            (this.ffExoprtDetail.clientType != "3"|| this.ffExoprtDetail.clientType != "4")
          ) {
            this.ffExoprtDetail.importerClientId = this.ffExoprtDetail.clientId;
          }

          if (this.ffExoprtDetail.handoverLocationId != "") {
            let dummyPOR = this.handoverListData.filter((x) => {
              return x.pickupId == this.ffExoprtDetail.handoverLocationId;
            });
            if (dummyPOR.length > 0 && this.ffExoprtDetail.transportType == "Export") {
              this.ffExoprtDetail.PORFromTPT = dummyPOR[0].pickupLocation;
              this.ffExoprtDetail.PORlocationId = dummyPOR[0].pickupId;
            } else {
              this.ffExoprtDetail.PORFromTPT = "";
            }
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      selectDateFormat,
      confirm: {
        title: "CONFIRMATION",
        contentHtml:
          " <strong>Data cannot be updated onces submitted.</strong><br> Are you sure to proceed ?",
        ok: "Save & Submit",
        cancel: "Cancel ",
      },
      vertical: "bottom",
      horizontal: "center",
      duration: 1700,
      snackbarData: "",
      AutoContainerType: {},
      flavours: ["Orange", "Grape", "Apple", "Lime", "Very Berry"],
      windowSize: "",
      clientIntro: "",
      allSelected: false,
      hideQuoteMode: false,
      indeterminate: false,
      showFFCCAccordina: false,
      showTPTAccordian: false,
      allFFDataTable: [],
      allCCDataTable: [],
      tempCCDataTable: [],
      allTPTDataTable: [],
      fieldsCC: [
        {
          key: "ccQId",
          mainkey: "ccQId",
          label: "Quatation No.",
          sortable: true,
          sortDirection: "DESC",
        },
        {
          key: "ccType",
          mainkey: "ccType",
          label: "Quotation Details",
          sortable: true,
          sortDirection: "DESC",
        },
      ],
      fieldsTPT: [
        {
          key: "tptQId",
          mainkey: "tptQId",
          label: "Quatation No.",
          sortable: true,
          sortDirection: "DESC",
        },
        {
          key: "baseCost",
          mainkey: "baseCost",
          label: "Quotation Details",
          sortable: true,
          sortDirection: "DESC",
        },
        {
          key: "otherCharge",
          mainkey: "otherCharge",
          label: "Other  Charges",
          sortable: true,
          sortDirection: "DESC",
        },
      ],
      selectedFFRadio: "",
      selectedCCRadio: "",
      selectedTPTRadio: "",
      showAdvSearch: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      isLoading: false,
      factoryDetail: [],
      tempfactoryDetail: [],
      opnTPT: false,
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse",
        },
      ],

      containerInfoName: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
        // {
        //   containerInfoVal: "FclConsolidation",
        //   containerInfoText: "FCL Consolidation"
        // },
        // {
        //   containerInfoVal: "LclConsolidation",
        //   containerInfoText: "LCL Consolidation"
        // }
      ],
      ffActivityAir: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },

        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation",
        },
      ],
      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable",
        },
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY",
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP",
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door",
        },
      ],
      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      deliveryTermsName_bak: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],

      showAdd: false,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      hideTPTSection: false,
      hideCCSection: false,
      hideFFSection: false,
      hideCContatiner: false,
      allAgentColoader: [],
      ffShippingArray: [],
      CommodityAll: {},
      autoClientName: {},
      ffExoprtDetail: {
        commodityType: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        airPickup: "",
        lclNetWgt: "",
        lclGrossWgt: "",
        selectedDimmen: "",
        coLoaderId: "",
        PORFromTPT: "",
        onAccountOf: "",
        multipleContainerType: [],
        multipleContainerTypeId: [],
        selectedFFENQID: [],
        selectedFFQID: [],
        multiContainerId: [],
        enqDate: "",
        selectedTPTQuotationId: "",
        enqIdTPT: "",
        selectedCCQuotationId: "",
        selectedFFQuotationId: "",
        enqIdCC: "",
        enqIdFF: "",
        mainEnquiryId: "",
        BranchCode: "",
        grossVolWgtAir: "",
        noOfPkg: "",
        airlineId: "",
        ffShippingWiseId: "",
        tptEnquiry: [],
        ffEnquiry: [],
        ccEnquiry: [],
        ccType: "",
        tptType: "",
        tptClientStatus: "",
        ccClientStatus: "",
        ccCha: "",
        transporterName: "",
        allModuleId: "",
        transContainerTypeId: "",
        transContainerType: "",
        pickupLocationId: "",
        stuffingLocationId: "",
        handoverLocationId: "",
        containerId: "",
        clientId: "",
        shippingId: "",
        shipmentType: "1",
        transportType: "",
        stuffingType: "",
        containerInfo: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        deliveryMode: "",
        deliveryTerms: "",
        exporterClientId: "",
        importerClientId: "",
        commodityId: "",
        IMDGClass: "",
        otherComodity: "",
        itemDescription: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        remark: "",
        portType: "",
        jobType: [],
        noOfContainer: "",
        clientType: "1",
        airportDeparture: "",
        airportDestination: "",
        cargoReceived: "",
        destinationModeAir: "",
        doorDestinationfpod: "",
        estimatedDate: "",
        fk_lead_id: "",
        newClientName: "",
        newClientEmail: "",
        newClientAddress: "",
        newClientPhoneNumber: "",
        ffClientStatus: "",
        otherExpoName: "",
        otherImpoName: "",
        othersLocDetails: "",
        ffQuoteRejectCount: "",
        ccQuoteRejectCount: "",
        tptQuoteRejectCount: "",
        EnquiryCreated: "",
        EnquiryUpdated: "",
      },
      transportTypeError: "",
      shipmentTypeError: "",
      clientIdError: "",
      clientTypeError: "",
      pickupLocationIdError: "",
      stuffingLocationIdError: "",
      newClientNameError: "",
      newClientEmailError: "",
      newClientAddressError: "",
      newClientPhoneNumberError: "",
      handoverLocationIdError: "",
      // transContainerTypeIdError: "",
      containerInfoError: "",
      shipmentTypeError: "",
      commodityTypeError: "",
      importerClientIdError: "",
      otherComodityError: "",
      exporterClientIdError: "",
      stuffingTypeError: "",
      airportDepartureError: "",
      airportDestinationError: "",
      cargoReceivedError: "",
      destinationModeAirError: "",
      shippingIdError: "",
      PORlocationIdError: "",
      LPlocationIdError: "",
      PODLocationIdError: "",
      finalPlaceLocationIdError: "",

      deleteId: "",

      containerModal: {
        containerType: "",
        noOfContainer: "",
        containerTypeId: "",
      },
      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      allClientAndOverSea: [],
      getCLientData: ["gfdg"],
      getImporterExpo: ["gfdg"],
      destinationDelieveryList: [
        {
          type: "upto Airport",
          val: "1",
        },
        {
          type: "DOOR",
          val: "2",
        },
      ],
      cargoReceivedList: [
        {
          type: "Airport",
          val: "1",
        },
        {
          type: "Warehouse",
          val: "2",
        },
      ],
      statusModal: {
        tptClientStatus: "",
      },
      statusList: [
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],
      clientTypeList: [
        {
          type: "Client",
          val: "1",
        },
        {
          type: "Lead",
          val: "2",
        },
        {
          type: "Overseas Agent",
          val: "3",
        },
        {
          type: "Consignee",
          val: "4",
        },
      ],
      showSegmentArray: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      errorAtleastOne: "",

      ffExportError: [
        "Please Select Client Name",
        "Please Select Place of Receipt",
        "Please Select Load  Port Name",
        "Please Select Port  of Discharge",
        "Please Select final Delievery",
        "Please Select Commidity",
        "Please Select Stuffing type",
        "Please Select Delivery  Terms",
        "Please Select Delivery Mode",
        "Please Select Exporter Name",
        "Please Select Importer Name",
        "Please Select Shipment type",
        "Please Select FF Activity",
        "Please Select Container type",
        "Please Select Handover Location",
        "Please Select Stuffing Location",
        "Please Select Pickup Location",
        "Please Select Transport Type",
        "Please Select Shipping Line",
      ],
      ffExporterrorList: {
        clientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        //  commodityId: "",
        stuffingType: "",
        deliveryTerms: "",

        deliveryMode: "",
        exporterClientId: "",
        importerClientId: "",
        shipmentType: "",
        containerInfo: "",
        transContainerTypeId: "",
        handoverLocationId: "",
        stuffingLocationId: "",
        pickupLocationId: "",
        transportType: "",
        shippingId: "",
      },

      ContainerError: ["Please Select Container", "Please Enter No of Container"],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: "",
      },
      getPortDischargeList: [],
      PortLoadList: [],
      AirPortLoadList: [],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      allModuleIdNew:
        this.$sessionsStorage.get("editallModuleId") != "" ||
        this.$sessionsStorage.get("editallModuleId") != undefined
          ? this.$sessionsStorage.get("editallModuleId")
          : "",
      jobTypeSelectVal: false,
      otherServicesVal: false,
      showQuoteButton: false,
      docURL: URL_BASE_DOC,
      getShippingLineData: ["zim"],
      getCommodityData: ["ZIM"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: [],
      handoverListData: [],
      getAlllocationListDataFactory: [],
      tempFactoryData: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],

      finalAllPlaceData: [],
      airLineList: [],
      getColoaderNameList: [],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      newJobType: [],
      openExpoInput: false,
      dialogOpened: false,
      openImpoInput: false,
      showFFSelectedExistQ: [],
      showCCSelectedExistQ: [],
      showTPTSelectedExistQ: [],
      oldTransport: "",
      oldShipment: "",
      EnqNo:"",
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
    FilterCBModal,
    // Loading,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleEnquiry() {
      return this.ffExoprtDetail.mainEnquiryId != "" ? true : false;
    },

    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
  },
  methods: {
    FactoryPickupSame(stuffingLocationId) {
      this.ffExoprtDetail.pickupLocationId = stuffingLocationId;
      this.ffExoprtDetail.containerInfo = "lcl";
    },
    FactoryContainerType() {
      if (
        this.ffExoprtDetail.shipmentType == "1" &&
        this.ffExoprtDetail.transportType == "Export" &&
        this.ffExoprtDetail.multipleContainerType[0] == "LCL Container"
      ) {
        this.ffExoprtDetail.containerInfo = "lcl";

        // alert(this.ffExoprtDetail.containerInfo);
      }
    },
    ColoderBasedShipppingLine(coLoaderId) {
      this.ffExoprtDetail.shippingId = coLoaderId;
    },
    getClientFactoryLoc() {
      if (this.ffExoprtDetail.clientId != "") {
        let facArry = this.tempfactoryDetail.filter((x) => {
          return (
            x.clientId == this.ffExoprtDetail.clientId && x.isMultifactoryActive == "1"
          );
        });
        this.getAlllocationListDataFactory = [];
        if (facArry.length > 0) {
          console.log(facArry.length);
          this.getAlllocationListDataFactory.unshift(...facArry);
        }

        let obj = {
          pickupId: "00000",
          pickupLocation: "Show Other Locations",
        };
        this.getAlllocationListDataFactory.unshift(obj);
        let clientInt = this.getCLientData.filter((y) => {
          return y.clientId == this.ffExoprtDetail.clientId;
        });
        if (clientInt.length > 0) {
          console.log("clientInt=>", clientInt); //companyType
          this.clientIntro =
            "Email : " +
            clientInt[0].email +
            "   Company Type : " +
            clientInt[0].companyType +
            "   State : " +
            clientInt[0].stateName;
        }
      }
    },
    showExistQuote() {
      this.getAllQuotation();
      this.$refs["QuotePop"].show();
    },
    getDataLocations() {
      if (
        this.ffExoprtDetail.shipmentType != "" &&
        this.ffExoprtDetail.transportType != "" &&
        this.oldTransport != this.ffExoprtDetail.transportType &&
        this.oldShipment != this.ffExoprtDetail.transportType
      ) {
        this.oldTransport = this.ffExoprtDetail.transportType;
        this.oldShipment = this.ffExoprtDetail.shipmentType;
        let vehicle_drive = {
          shipmentType: this.ffExoprtDetail.shipmentType,
          transportType: this.ffExoprtDetail.transportType,
          clientType: this.ffExoprtDetail.clientType,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/getDataEnquiryLocations.php`,
          data: JSON.stringify(vehicle_drive),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.LocationDetailsTransport.length > 0) {
                this.getAlllocationListData = data.LocationDetailsTransport;
                this.handoverListData = data.LocationDetailsTransport;
              }
              if (data.LocationDetailsIcdIndiaSea.length > 0) {
                this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
              }

              if (data.LocationDetailsIndiaSea.length > 0) {
                this.PortLoadList = data.LocationDetailsIndiaSea;
              }

              if (data.LocationDetailsSeaPortsNotIndia.length > 0) {
                this.getPortDischargeList = data.LocationDetailsSeaPortsNotIndia;
                this.finalAllPlaceData = data.LocationDetailsSeaPortsNotIndia;
              }

              if (data.LocationDetailsClientFac.length > 0) {
                this.tempFactoryData = data.LocationDetailsClientFac;
                this.getAlllocationListDataFactory = data.LocationDetailsClientFac;
              }
              if (data.LocationDetailsAirPorts.length > 0) {
                this.AirPortLoadList = data.LocationDetailsAirPorts;
                this.AirIcdPOrtList = data.LocationDetailsAirPorts;
              }
            }
          })
          .catch((error) => {});
      }
    },
    fetchType() {
      this.transportTypeName = [];
      if(this.ffExoprtDetail.clientType == "4"){
          this.$store.dispatch(
            "common/setAllClientList",
            JSON.stringify({
              itemCode: "ClientList",
              ClientType:"Consignee",
            })
          );
      }else{
        this.$store.dispatch(
          "common/setAllClientList",
          JSON.stringify({
            itemCode: "ClientList",
            ClientType:"Client",
          })
        );
      }
      if (this.ffExoprtDetail.clientType == "3" || this.ffExoprtDetail.clientType == "4") {
        let overSeaArry = this.allClientAndOverSea.filter((x) => {
          return x.clientId > 0;
          // return x.agentColoderId > 0;
          // return x.agentColoderId != "0";
        });
        if (overSeaArry.length > 0) {
          this.getCLientData = overSeaArry;
        }
        this.transportTypeName = [];
        let Arry = [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export",
          },
        ];
        this.transportTypeName = Arry;

        // this.ffExoprtDetail.transportType = "Export";
        // if (this.newJobType.indexOf("FF") < 0) {
        //   this.alert.content =
        //     "Overseas Agent Execution must include Freight Forwarding..!   Please Select Freight to continue";
        //   this.$refs["addPop22"].open();
        //   this.ffExoprtDetail.clientType = "";
        // }
      } else if (this.ffExoprtDetail.clientType == "1") {
        let cArry = this.allClientAndOverSea.filter((x) => {
          return x.clientType == "Client";
        });
        if (cArry.length > 0) {
          this.getCLientData = cArry;
        }
        this.transportTypeName = [];
        let Arry = [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export",
          },
          {
            transportTypeVal: "Import",
            transportTypeText: "Import",
          },
        ];
        this.transportTypeName = Arry;
      } else {
        this.transportTypeName = [];
        let Arry = [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export",
          },
          {
            transportTypeVal: "Import",
            transportTypeText: "Import",
          },
        ];
        this.transportTypeName = Arry;
      }
    },
    PrintFF(item) {
      window.open(`${this.docURL}/FF_QUOTATION_PDF/` + item);
    },
    PrintCC(item) {
      window.open(`${this.docURL}/CC_QUOTATION_PDF/` + item);
    },
    PrintTPT(item) {
      window.open(`${this.docURL}/TPT_QUOTATION_PDF/` + item);
    },
    showQuoteDetailsPop() {
      this.$refs["QuotePop"].show();
    },
    closeDialogQuoteSave() {
      this.$refs["QuotePop"].hide();
    },
    closeDialogQuote() {
      this.allCCDataTable = [];
      this.allFFDataTable = [];
      this.allTPTDataTable = [];
      this.hideCCSection = false;
      this.hideFFSection = false;
      this.hideCContatiner = false;
      this.ffExoprtDetail.selectedFFQuotationId = "";
      // this.ffExoprtDetail.othersLocDetails = item.multipleContainerType;

      this.ffExoprtDetail.enqIdFF = "";

      this.ffExoprtDetail.selectedCCQuotationId = "";
      this.ffExoprtDetail.enqIdCC = "";
      this.hideTPTSection = false;
      this.ffExoprtDetail.selectedTPTQuotationId = "";
      this.ffExoprtDetail.PORFromTPT == "";
      this.ffExoprtDetail.enqIdTPT = "";
      this.$refs["QuotePop"].hide();
    },
    clearFFRadio() {
      this.selectedFFRadio = "";
      this.ffExoprtDetail.selectedFFQuotationId = "";
      this.ffExoprtDetail.enqIdFF = "";
    },

    clearCCRadio() {
      this.selectedCCRadio = "";
      this.ffExoprtDetail.selectedCCQuotationId = "";
      this.ffExoprtDetail.enqIdCC = "";
    },
    clearTPTRadio() {
      this.hideTPTSection = false;
      this.selectedTPTRadio = "";
      this.ffExoprtDetail.selectedTPTQuotationId = "";
      this.ffExoprtDetail.enqIdTPT = "";
    },
    deleteContainer(item) {
      let i = this.ffExoprtDetail.multipleContainerType.indexOf(item);

      this.ffExoprtDetail.multipleContainerType.splice(i, 1);
      this.ffExoprtDetail.multipleContainerTypeId.splice(i, 1);
    },
    masterCallbackContainer(item) {
      if (this.ffExoprtDetail.multipleContainerType.length > 0) {
        let i = this.ffExoprtDetail.multipleContainerType.indexOf(item.containerType);

        if (i < 0) {
          this.ffExoprtDetail.multipleContainerType.push(item.containerType);
          this.ffExoprtDetail.multipleContainerTypeId.push(item.containerTypeId);
        }
      } else {
        this.ffExoprtDetail.multipleContainerType.push(item.containerType);
        this.ffExoprtDetail.multipleContainerTypeId.push(item.containerTypeId);
      }
      if (this.ffExoprtDetail.multipleContainerType.length > 0) {
        this.FactoryContainerType();
      }
    },
    pickUpExpClient(exporterClientId){
      console.log('pickUpExpClient called with:', exporterClientId);
      console.log('Current clientType:', this.ffExoprtDetail.clientType);
      console.log('Current exporterClientId before:', this.ffExoprtDetail.exporterClientId);

      // Update the exporterClientId for overseas clients
      if(this.ffExoprtDetail.clientType=="3" || this.ffExoprtDetail.clientType=="4"){
        this.ffExoprtDetail.exporterClientId = exporterClientId;
        console.log('Updated exporterClientId to:', this.ffExoprtDetail.exporterClientId);
        this.$forceUpdate(); // Force re-render
      }
    },
    showExpInput() {
      if (this.ffExoprtDetail.exporterClientId != "") {
        let dummyExporter = this.getImporterExpo.filter((x) => {
          return x.clientId == this.ffExoprtDetail.exporterClientId;
        });
        if (dummyExporter.length > 0) {
          if (dummyExporter[0].clientName == "Others") {
            this.openExpoInput = true;
          } else {
            this.openExpoInput = false;
          }
        }
      }
      if (this.ffExoprtDetail.importerClientId != "") {
        let dummyImporter = this.getImporterExpo.filter((x) => {
          return x.clientId == this.ffExoprtDetail.importerClientId;
        });
        if (dummyImporter.length > 0) {
          if (dummyImporter[0].clientName == "Others") {
            this.openImpoInput = true;
          } else {
            this.openImpoInput = false;
          }
        }
      }
    },
    selectedTPTQuotation(id, enqId, item) {
      if (item.validityDate < item.currDate) {
        this.alert.content =
          "Expired Quotation Selected.This Will be sent to Pricing For Further Process";
        this.$refs["addPop22"].open();
      }
      this.showTPTSelectedExistQ = [];
      this.ffExoprtDetail.PORFromTPT = item.handover;
      this.ffExoprtDetail.PORlocationId = item.handoverIdTPT;
      this.showTPTSelectedExistQ.push(item);
      this.hideTPTSection = true;
      this.hideCContatiner = true;
      this.ffExoprtDetail.selectedTPTQuotationId = id;
      this.ffExoprtDetail.enqIdTPT = enqId;
    },
    selectedCCQuotation(id, enqId, item) {
      if (item.validityDate < item.currDate) {
        this.alert.content =
          "Expired Quote is Selected.Approval Will be required Before Execution.";
        this.$refs["addPop22"].open();
      }
      this.showCCSelectedExistQ = [];
      this.showCCSelectedExistQ.push(item);

      this.hideCCSection = true;
      this.hideCContatiner = true;
      this.ffExoprtDetail.selectedCCQuotationId = id;
      this.ffExoprtDetail.enqIdCC = enqId;
    },
    selectedFFQuotation(id, enqId, item) {
      if (item.ffvalidityDate < item.currDate) {
        this.alert.content =
          "Expired Quote is Selected.Approval Will be required Before Execution.";
        this.$refs["addPop22"].open();
      }
      this.ffExoprtDetail.selectedFFQuotationId = id;
      this.ffExoprtDetail.enqIdFF = enqId;

      // this.allCCDataTable = [];
      // let DummyCCQuot = [];
      // DummyCCQuot = this.tempCCDataTable;
      // // let ffCon = item.multipleContainerType.split(",");
      // DummyCCQuot.map(y => {
      //   // let ccCon = y.multipleContainerType.split(",");
      //   if (y.POR == item.POR  ) {
      //     console.log("abc");
      //     this.allCCDataTable.push(y);
      //   }
      // });

      let DummyCCQuot = [];
      let selectedArry = [];
      selectedArry.push(item);
      this.showFFSelectedExistQ = selectedArry;

      console.log(this.showFFSelectedExistQ);

      DummyCCQuot = this.tempCCDataTable;

      this.allCCDataTable = [];
      selectedArry.map((x) => {
        let ffCon = x.multipleContainerType.split(",");
        DummyCCQuot.map((y) => {
          let ccCon = y.multipleContainerType.split(",");
          let checker = (arr, target) => target.every((v) => arr.includes(v));

          if (x.POR == y.POR && checker(ccCon, ffCon) == true) {
            this.allCCDataTable.push(y);
          }
        });
      });

      this.hideCCSection = true;
      this.hideFFSection = true;
      this.hideCContatiner = true;

      // this.ffExoprtDetail.othersLocDetails = item.multipleContainerType;
      // console.log(this.ffExoprtDetail.othersLocDetails)
    },

    getAllQuotation() {
      let arryC = this.getCLientData.filter((x) => {
        return x.clientId == this.ffExoprtDetail.clientId;
      });
      if (arryC.length > 0) {
        if (arryC[0].clientType == "Overseas") {
          this.ffExoprtDetail.clientType = "3";
        }else if (arryC[0].clientType == "Consignee") {
          this.ffExoprtDetail.clientType = "4";
        } else {
          console.log("client or lead");
        }
      }
      let vehicle_drive = {
        itemCode: "itemCode",
        ccCheck: this.newJobType.indexOf("CC"),
        tptCheck: this.newJobType.indexOf("TPT"),
        ffCheck: this.newJobType.indexOf("FF"),
        clientId: this.ffExoprtDetail.clientId,
        transportType: this.ffExoprtDetail.transportType,
        shipmentType: this.ffExoprtDetail.shipmentType,
        containerType: this.ffExoprtDetail.multipleContainerTypeId,
        pickupLocation: this.ffExoprtDetail.pickupLocationId,
        stuffingLocation: this.ffExoprtDetail.stuffingLocationId,
        handoverLocation: this.ffExoprtDetail.handoverLocationId,
        PORlocation: this.ffExoprtDetail.PORlocationId,
        LPlocation: this.ffExoprtDetail.LPlocationId,
        PODlocation: this.ffExoprtDetail.PODLocationId,
        FPODlocation: this.ffExoprtDetail.finalPlaceLocationId,
        airportDeparture: this.ffExoprtDetail.airportDeparture,
        airportDestination: this.ffExoprtDetail.airportDestination,
      };
      console.log(vehicle_drive);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchAllQuotationEnquiry.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);

            if (data.allCCData.length > 0) {
              this.allCCDataTable = data.allCCData;
              this.tempCCDataTable = data.allCCData;
            }
            if (data.allTPTData.length > 0) {
              this.allTPTDataTable = data.allTPTData;
            }
            if (data.allFFData.length > 0) {
              this.allFFDataTable = data.allFFData;
            }

            if (
              data.allCCData.length > 0 ||
              data.allTPTData.length > 0 ||
              data.allFFData.length > 0
            ) {
              this.$refs["QuotePop"].show();
              this.showQuoteButton = true;
            } else {
              this.showQuoteButton = false;
            }

            // this.doLoadingClose();
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    openAdvanceSearch() {
      this.getAllQuotation();
      this.showAdvSearch = true;
    },
    hideAdvanceSearch() {
      this.showAdvSearch = false;
      this.hideTPTSection = false;
      this.hideCCSection = false;
      this.hideFFSection = false;
      this.hideCContatiner = false;
      this.getAllQuotation();
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    getLocationList(event, type, vmodelArray) {
      if (this.ffExoprtDetail.stuffingLocationId == "00000") {
        this.getAlllocationListDataFactory = [];
        this.getAlllocationListDataFactory.unshift(...this.tempFactoryData);
        //this.getAlllocationListDataFactory=this.tempFactoryData
        let obj = {
          pickupId: "00001",
          pickupLocation: "Show Client Factory",
        };
        this.getAlllocationListDataFactory.unshift(obj);
        this.ffExoprtDetail.stuffingLocationId = "";
      }

      if (this.ffExoprtDetail.stuffingLocationId == "00001") {
        if (this.ffExoprtDetail.clientId != "") {
          this.getAlllocationListDataFactory = [];
          let facArry = this.tempfactoryDetail.filter((x) => {
            return (
              x.clientId == this.ffExoprtDetail.clientId && x.isMultifactoryActive == "1"
            );
          });

          if (facArry.length > 0) {
            console.log(facArry.length);
            this.getAlllocationListDataFactory.unshift(...facArry);
          }
          let obj = {
            pickupId: "00000",
            pickupLocation: "Show Other Locations",
          };
          this.getAlllocationListDataFactory.unshift(obj);
        }
        this.ffExoprtDetail.stuffingLocationId = "";
      }

      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
      if (
        this.hideQuoteMode == false &&
        this.ffExoprtDetail.mainEnquiryId == "" &&
        this.ffExoprtDetail.shipmentType == "1" &&
        this.dialogOpened == false
      ) {
        if (
          this.newJobType.indexOf("FF") >= 0 &&
          this.newJobType.indexOf("CC") >= 0 &&
          this.newJobType.indexOf("TPT") >= 0
        ) {
          if (
            this.ffExoprtDetail.shipmentType != "" &&
            this.ffExoprtDetail.transportType != "" &&
            this.ffExoprtDetail.clientId != "" &&
            this.ffExoprtDetail.pickupLocationId != "" &&
            this.ffExoprtDetail.handoverLocationId != "" &&
            this.ffExoprtDetail.stuffingLocationId != "" &&
            this.ffExoprtDetail.PORlocationId != "" &&
            this.ffExoprtDetail.LPlocationId != "" &&
            this.ffExoprtDetail.PODLocationId != "" &&
            this.ffExoprtDetail.finalPlaceLocationId != "" &&
            this.ffExoprtDetail.multipleContainerTypeId.length > 0
          ) {
            this.getAllQuotation();
            this.dialogOpened = true;
          } else {
            console.log("Please Select all Fields To get Existing Quote ");
          }
        } else if (this.newJobType.indexOf("FF") >= 0) {
          if (
            this.ffExoprtDetail.shipmentType != "" &&
            this.ffExoprtDetail.transportType != "" &&
            this.ffExoprtDetail.clientId != "" &&
            this.ffExoprtDetail.PORlocationId != "" &&
            this.ffExoprtDetail.LPlocationId != "" &&
            this.ffExoprtDetail.PODLocationId != "" &&
            this.ffExoprtDetail.finalPlaceLocationId != "" &&
            this.ffExoprtDetail.multipleContainerTypeId.length > 0
          ) {
            this.getAllQuotation();
            this.dialogOpened = true;
          } else {
            console.log("Please Select all Fields To get Existing Quote ");
          }
        } else if (this.newJobType.indexOf("CC") >= 0) {
          if (
            this.ffExoprtDetail.shipmentType != "" &&
            this.ffExoprtDetail.transportType != "" &&
            this.ffExoprtDetail.clientId != "" &&
            this.ffExoprtDetail.PORlocationId != "" &&
            this.ffExoprtDetail.multipleContainerTypeId.length > 0
          ) {
            this.getAllQuotation();
            this.dialogOpened = true;
          } else {
            console.log("Please Select all Fields To get Existing Quote ");
          }
        } else {
          if (
            this.ffExoprtDetail.shipmentType != "" &&
            this.ffExoprtDetail.transportType != "" &&
            this.ffExoprtDetail.clientId != "" &&
            this.ffExoprtDetail.pickupLocationId != "" &&
            this.ffExoprtDetail.handoverLocationId != "" &&
            this.ffExoprtDetail.stuffingLocationId != "" &&
            this.ffExoprtDetail.multipleContainerTypeId.length > 0
          ) {
            this.getAllQuotation();
            this.dialogOpened = true;
          } else {
            console.log("Please Select all Fields To get Existing Quote ");
          }
        }
      }
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    methodsHere() {},
    showMultiple() {
      this.ffExoprtDetail.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getPortId1(item) {
      this.ffExoprtDetail.toportId = item.portId;
    },
    getPortId2(item) {
      this.ffExoprtDetail.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    // CommodityCallback(item) {
    //   this.ffExoprtDetail.commodityId = item.commodityId;
    //   this.ffExoprtDetail.commodityType = item.commodityType;
    //   this.ffExoprtDetail.itemDescription = item.itemDescription;
    // },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },
  goToDomestic(){
    this.$router.push({
      path: "/mainEnquiry/transportEnq",
    });
  },
    jobTypeSelect(value, index) {
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
        if (value == "TPT") {
          this.showTPTAccordian = false;
        } else {
          this.showFFCCAccordina = false;
        }
      } else {
        this.newJobType.push(value);
        if (value == "TPT") {
          this.showTPTAccordian = true;
        } else {
          this.showFFCCAccordina = true;
        }
      }
      if (
        this.newJobType.indexOf("TPT") < 0 &&
        this.ffExoprtDetail.selectedTPTQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing TPT Quotation";
        this.$refs["addPop22"].open();
      }
      if (
        this.newJobType.indexOf("CC") < 0 &&
        this.ffExoprtDetail.selectedCCQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing CC Quotation";
        this.$refs["addPop22"].open();
      }
      if (
        this.newJobType.indexOf("FF") < 0 &&
        this.ffExoprtDetail.selectedFFQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing FF Quotation";
        this.$refs["addPop22"].open();
      }
    },
    getAllExistQuote() {
      this.getAllQuotation();
    },
    JqueryFun() {
      return $(function () {
        $("#CCTable").DataTable();
        $("#TPTTable").DataTable();
        $("#FFTable").DataTable();
      });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;
      this.commodityTypeError = "";
      if (this.ffExoprtDetail.clientId == "" && this.ffExoprtDetail.clientType == "1") {
        $("#clientId").focus();
        this.clientIdError = "Select client name";
        validate_new = false;
      }

      if (this.ffExoprtDetail.clientType == "") {
        $("#clientType").focus();
        this.clientTypeError = "Select client type";
        validate_new = false;
      }

      if (this.ffExoprtDetail.transportType == "") {
        $("#transportType").focus();
        this.transportTypeError = "Select Transport Type";
        validate_new = false;
      }
      if (this.ffExoprtDetail.shipmentType == "") {
        $("#transportType").focus();
        this.shipmentTypeError = "Select Shipment Type";
        validate_new = false;
      }
      let newValJobType = [];
      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newValJobType.push(x.value);
        }
      });

      // this.ffExoprtDetail["jobType"] = newVal;
      // alert(this.ffExoprtDetail["jobType"]);
      if (this.ffExoprtDetail.shipmentType == "1") {
        if (newValJobType.indexOf("FF") >= 0) {
          if (this.ffExoprtDetail.commodityType == "") {
            this.commodityTypeError = "Select Commodity Type";
            validate_new = false;
            // this.alert.content = "Select Commodity Type";
            // this.$refs["addPop"].open();
            // return false;
          }
        }
      } else {
        this.commodityTypeError = "";
      }

      if (this.hideTPTSection == false && this.ffExoprtDetail.shipmentType == "1") {
        if (
          this.ffExoprtDetail.pickupLocationId == "" &&
          this.newJobType.indexOf("TPT") >= 0
        ) {
          $("#pickupLocationId").focus();
          this.pickupLocationIdError = "Select Pickup Location";
          validate_new = false;
        }
        if (
          this.ffExoprtDetail.stuffingLocationId == "" &&
          this.newJobType.indexOf("TPT") >= 0
        ) {
          $("#stuffingLocationId").focus();
          this.stuffingLocationIdError = "Select Factory  Location";
          validate_new = false;
        }

        if (
          this.ffExoprtDetail.handoverLocationId == "" &&
          this.newJobType.indexOf("TPT") >= 0
        ) {
          $("#handoverLocationId").focus();
          this.handoverLocationIdError = "Select Handover Location";
          validate_new = false;
        }
        // if (
        //   this.ffExoprtDetail.transContainerTypeId == "" &&
        //   this.newJobType.indexOf("TPT") >= 0 &&
        //   this.ffExoprtDetail.shipmentType == "1"
        // ) {
        //   $("#transContainerTypeId").focus();
        //   this.transContainerTypeIdError = "Select Container Type";
        //   validate_new = false;
        // }
      }

      if (
        this.newJobType.indexOf("CC") >= 0 ||
        (this.ffExoprtDetail.shipmentType == "1" && this.newJobType.indexOf("FF") >= 0)
      ) {
        if (this.ffExoprtDetail.containerInfo == "") {
          $("#containerInfo").focus();
          this.containerInfoError = "Select FF Activity";
          validate_new = false;
        }

        if (this.ffExoprtDetail.shipmentType == "") {
          $("#shipmentType").focus();
          this.shipmentTypeError = "Select Shipping Type";
          validate_new = false;
        }

        if (
          this.ffExoprtDetail.importerClientId == "" &&
          this.ffExoprtDetail.clientType == "1"
        ) {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }
        // if (this.ffExoprtDetail.commodityId == "") {
        //   $("#commodityType").focus();
        //   this.commodityTypeError = "Select Commodity";
        //   validate_new = false;
        // }

        if (
          this.ffExoprtDetail.exporterClientId == "" &&
          this.ffExoprtDetail.clientType == "1"
        ) {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }

        if (
          this.ffExoprtDetail.stuffingType == "" &&
          this.ffExoprtDetail.shipmentType == "1"
        ) {
          $("#stuffingType").focus();
          this.stuffingTypeError = "Select Stuffing Type";
          validate_new = false;
        }
        // if (this.ffExoprtDetail.shippingId == "") {
        //   $("#shippingId").focus();
        //   this.shippingIdError = "Select Shipping Line";
        //   validate_new = false;
        // }

        if (this.hideCCSection == false && this.ffExoprtDetail.shipmentType == "1") {
          if (this.ffExoprtDetail.PORlocationId == "") {
            $("#PORlocationId").focus();
            this.PORlocationIdError = "Select Place Of Receipt";
            validate_new = false;
          }
          if (this.newJobType.indexOf("FF") >= 0 && this.hideFFSection == false) {
            if (this.ffExoprtDetail.LPlocationId == "") {
              $("#LPlocationId").focus();
              this.LPlocationIdError = "Select Load Port";
              validate_new = false;
            }
            if (this.ffExoprtDetail.PODLocationId == "") {
              $("#PODLocationId").focus();
              this.PODLocationIdError = "Select Port Of Discharge";
              validate_new = false;
            }
            if (this.ffExoprtDetail.finalPlaceLocationId == "") {
              $("#finalPlaceLocationId").focus();
              this.finalPlaceLocationIdError = "Select Final Place Of Delivery";
              validate_new = false;
            }
          } else {
            this.LPlocationIdError = "";
            this.PODLocationIdError = "";
            this.finalPlaceLocationIdError = "";
          }
        }
      }

      if (this.ffExoprtDetail.shipmentType == "2" && this.newJobType.indexOf("FF") >= 0) {
        if (this.ffExoprtDetail.importerClientId == "") {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }

        if (this.ffExoprtDetail.exporterClientId == "") {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }
        if (this.hideFFSection == false) {
          if (this.ffExoprtDetail.airportDeparture == "") {
            $("#airportDeparture").focus();
            this.airportDepartureError = "Select Airport Departure";
            validate_new = false;
          }

          if (this.ffExoprtDetail.airportDestination == "") {
            $("#airportDestination").focus();
            this.airportDestinationError = "Select Airport Departure";
            validate_new = false;
          }
          if (this.ffExoprtDetail.cargoReceived == "") {
            $("#cargoReceived").focus();
            this.cargoReceivedError = "Select Cargo Received";
            validate_new = false;
          }

          if (this.ffExoprtDetail.destinationModeAir == "") {
            $("#destinationModeAir").focus();
            this.destinationModeAirError = "Select Cargo Received";
            validate_new = false;
          }
        }
      }

      if (this.ffExoprtDetail.clientType == "2") {
        if (this.ffExoprtDetail.newClientName == "") {
          $("#newClientName").focus();
          this.newClientNameError = "Enter Client Name";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }

        if (this.ffExoprtDetail.newClientPhoneNumber == "") {
          $("#newClientPhoneNumber").focus();
          this.newClientPhoneNumberError = "Enter Contact Number";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
        if (this.ffExoprtDetail.newClientEmail == "") {
          $("#newClientEmail").focus();
          this.newClientEmailError = "Enter Client Email";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
        if (this.ffExoprtDetail.newClientAddress == "") {
          $("#newClientAddress").focus();
          this.newClientAddressError = "Enter Client Address";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
      }

      if (validate_new != true) {
        if (this.commodityArray.length > 0) {
          window.scroll(0, 40);
        }
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },

    onCloseSubmit(type) {
      this.$refs["dialog5"].open();
      if (type == "ok") {
        this.addFFExport();
      }
    },
    addFFExport() {
      this.hideQuoteMode = true;
      if (
        this.newJobType.indexOf("TPT") < 0 &&
        this.ffExoprtDetail.selectedTPTQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing TPT Quotation";
        this.$refs["addPop22"].open();
        return false;
      }
      if (
        this.newJobType.indexOf("CC") < 0 &&
        this.ffExoprtDetail.selectedCCQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing CC Quotation";
        this.$refs["addPop22"].open();
        return false;
      }
      if (
        this.newJobType.indexOf("FF") < 0 &&
        this.ffExoprtDetail.selectedFFQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing FF Quotation";
        this.$refs["addPop22"].open();
        return false;
      }
      if (this.newJobType.length == 0) {
        this.alert.content = "Please select atleast one job type";
        this.$refs["addPop22"].open();
        return false;
      }

      if (
        this.newJobType.indexOf("FF") >= 0 ||
        this.newJobType.indexOf("CC") >= 0 ||
        this.newJobType.indexOf("TPT") >= 0
      ) {
        if (
          this.ffExoprtDetail.multipleContainerType.length == 0 &&
          this.hideCContatiner == false &&
          this.ffExoprtDetail.shipmentType == "1"
          // && this.ffExoprtDetail.transportType!='Domestic'
        ) {
          this.alert.content = "Please Add atleast one Container";
          this.$refs["addPop22"].open();
          return false;
        }
      }

      if (
        this.newJobType.indexOf("FF") >= 0 ||
        this.newJobType.indexOf("CC") >= 0
      ) {
        console.log("addFFExport - Validation: exporterClientId =", this.ffExoprtDetail.exporterClientId, "type:", typeof this.ffExoprtDetail.exporterClientId);
        const isInvalid = !this.ffExoprtDetail.exporterClientId || this.ffExoprtDetail.exporterClientId == "" || this.ffExoprtDetail.exporterClientId == null || this.ffExoprtDetail.exporterClientId == undefined || this.ffExoprtDetail.exporterClientId == "0";
        console.log("addFFExport - isInvalid =", isInvalid);
        if (isInvalid) {
          console.log("addFFExport - ERROR: Validation failed, showing error message");
          this.alert.content = "Please select Exporter Name";
          this.$refs["addPop22"].open();
          return false;
        } else {
          console.log("addFFExport - SUCCESS: Validation passed");
        }
      }

      if (this.ffExoprtDetail.ffClientStatus == "1") {
        if (this.ffExoprtDetail.ffShippingWiseId == "") {
          this.alert.content = "Please select Shipping Line Approved By Client";
          this.$refs["addPop22"].open();
          return false;
        }
      }
      //  if (this.ffExoprtDetail.shipmentType == "2") {
      //   let index = this.newJobType.indexOf("CC");
      //   if (index > -1) {
      //     this.newJobType.splice(index, 1);

      //   }
      //    let indexTPT = this.newJobType.indexOf("TPT");
      //   if (indexTPT > -1) {
      //     this.newJobType.splice(index, 1);

      //   }
      // }

      this.validateFFExport();

      if (this.commodityTypeError != "") {
        this.commodityTypeError = "Select Commodity Type";
        this.$refs["addPop22"].open();
        return false;
      }

      if (this.validate != false) {
        let newVal = [];

        this.showSegmentArray.map((x, index) => {
          if (this.ffExoprtDetail.jobType[index] == true) {
            newVal.push(x.value);
          }
        });

        this.ffExoprtDetail["jobType"] = newVal;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainEnquiry.php`,
          data: JSON.stringify(this.ffExoprtDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");
              if (this.ffExoprtDetail.mainEnquiryId == "") {
                this.snackbarData = "Data Added Successfully";
              } else {
                this.snackbarData = "Data Updated Successfully";
              }
              this.hideQuoteMode = false;
              this.$refs.snackbar.open();
              this.$router.push({
                path: "/viewMainEnquiryDetails/viewMainEnquiryDetails",
              });
            }
          })
          .catch((error) => {});
      }
    },

    onCloseAddFF() {
      this.$router.push({
        path: "/viewMainEnquiryDetails/viewMainEnquiryDetails",
      });
    },

    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    getData() {
      let array = [];
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",

        // ccCheck: this.newJobType.indexOf("CC"),
        // tptCheck: this.newJobType.indexOf("TPT"),
        // ffCheck: this.newJobType.indexOf("FF"),
        // clientId: this.ffExoprtDetail.clientId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataMainEnqTest.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.LocationDetailsFinal.length > 0) {
              this.getAlllocationListData = data.LocationDetailsFinal;
              this.handoverListData = data.LocationDetailsFinal;
              this.IcdPOrtList = data.LocationDetailsFinal;
              this.getPortDischargeList = data.LocationDetailsFinal;
              this.finalAllPlaceData = data.LocationDetailsFinal;
              this.PortLoadList = data.LocationDetailsFinal;
              this.getAlllocationListDataFactory = data.LocationDetailsFinal;
              this.AirPortLoadList = data.LocationDetailsFinal;
              this.AirIcdPOrtList = data.LocationDetailsFinal;
            }

            if (data.ClientfactoryDetail.length > 0) {
              this.tempfactoryDetail = data.ClientfactoryDetail;
            }
            if (data.UserData.length > 0) {
              this.ffExoprtDetail.BranchCode = data.UserData[0].BranchCode;
            }

            if (data.airLineList.length > 0) {
              this.airLineList = data.airLineList;
            }
            if (data.coloaderData.length > 0) {
              this.getColoaderNameList = data.coloaderData;
            }

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetailImpExp;
              this.allClientAndOverSea = data.clientdetail;
            } else {
              this.getCLientData = [];
            }
            if (data.clientdetailImpExp.length > 0) {
              this.getImporterExpo = data.clientdetailImpExp;
            } else {
              this.getImporterExpo = [];
            }

            // if (
            //   this.$sessionsStorage.get("editMainEnqId") == "" ||
            //   this.$sessionsStorage.get("editMainEnqId") == null
            // ) {
            //   this.getLocationList("A", "Air_Port", "AirPortLoadList");
            //   this.getLocationList("A", "Air_Port", "AirIcdPOrtList");

            //   // let today = new Date();
            //   // let dd = String(today.getDate()).padStart(2, "0");
            //   // let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            //   // let yyyy = today.getFullYear();

            //   // today = mm + "/" + dd + "/" + yyyy;
            //   // this.ffExoprtDetail.enqDate = today;
            // } else {
            //   console.log("Please Check Code")
            // }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            } else {
              this.getShippingLineData = [];
            }

            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }
           

            if (data.tptEnquiry.length > 0) {
              this.ffExoprtDetail.tptEnquiry = data.tptEnquiry;
            }
            if (data.ccEnquiry.length > 0) {
              this.ffExoprtDetail.ccEnquiry = data.ccEnquiry;
            }

            if (data.ffShippingArray.length > 0) {
              this.ffShippingArray = data.ffShippingArray;
            }

            if (data.ffEnquiry.length > 0) {
              this.ffExoprtDetail.ffEnquiry = data.ffEnquiry;
            }

            if (data.editAssignmentData.length > 0) {
              this.transportTypeName=[
                {
                  transportTypeVal: "Export",
                  transportTypeText: "Export",
                },
                {
                  transportTypeVal: "Import",
                  transportTypeText: "Import",
                },
                {
                  transportTypeVal: "Domestic",
                  transportTypeText: "Domestic",
                },
              ];
              this.EnqNo=data.editAssignmentData[0].mainEnquirySeries;
              Object.keys(data.editAssignmentData[0]).map((x) => {
                if (x == "jobType") {
                  array = data.editAssignmentData[0][x].split(",");
                  this.newJobType = data.editAssignmentData[0][x].split(",");
                } else if (x == "multipleContainerType") {
                // } else if (x == "multipleContainerType" && data.editAssignmentData[0].transportType!='Domestic') {
                  this.ffExoprtDetail[x] = data.editAssignmentData[0][x].split(",") || [];
                } else if (x == "multipleContainerTypeId") {
                // } else if (x == "multipleContainerTypeId" && data.editAssignmentData[0].transportType!='Domestic') {
                  this.ffExoprtDetail[x] = data.editAssignmentData[0][x].split(",") || [];
                }else {
                  this.ffExoprtDetail[x] = data.editAssignmentData[0][x] || "";
                }
              });

              if (this.ffExoprtDetail["tptStatus"] == "1") {
                this.ffExoprtDetail["tptClientStatus"] = "1";
              }

              if (this.ffExoprtDetail["ccStatus"] == "1") {
                this.ffExoprtDetail["ccClientStatus"] = "1";
              }
              if (this.ffExoprtDetail["ffStatus"] == "1") {
                this.ffExoprtDetail["ffClientStatus"] = "1";
                let array = this.ffShippingArray.filter((x) => {
                  return x.ffClientStatus == "1";
                });
                if (array.length > 0) {
                  this.ffExoprtDetail.ffShippingWiseId = array[0].ffShippingWiseId;
                }
              }

              this.ffExoprtDetail["jobType"] = [];

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.jobType[index] = true)
                  : (this.ffExoprtDetail.jobType[index] = false);
              });
              // if (this.ffExoprtDetail["portType"] == "Icd") {
              //   this.IcdPOrtList = data.LocationDetailsSEAPORT;
              // } else {
              //   this.IcdPOrtList = data.LocationDetailsSEAPORT;
              // }
            } else {
              // this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            this.isLoading = false;
            this.$refs["confirm"].show();
          }
        })
        .catch((error) => {});
    },

    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      window.history.go(-1);
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "FREIGHT FORWARDING (FF)",
          flex: "25",
        },
        {
          value: "CC",
          show: "CUSTOM CLEARANCE (CC)",
          flex: "25",
        },
        {
          value: "TPT",
          show: "TRANSPORTATION (TPT)",
          flex: "25",
        },
      ];
    },

    // Added 01-02-2023 start
    LeadClientDetails() {
      let values = this.$store.getters["common/getAllLeadCompList"].filter((x) => {
        return x.lead_comp_name == this.ffExoprtDetail.newClientName;
      });
      console.log("values=>", values);
      if (values.length > 0) {
        this.ffExoprtDetail.fk_lead_id = values[0].lead_id;
        this.ffExoprtDetail.exporterClientId = values[0].lead_id;
        if (
          values[0].lead_details != null &&
          values[0].lead_details != undefined &&
          values[0].lead_details != ""
        ) {
          let lead_details = JSON.parse(values[0].lead_details);
          console.log(lead_details);

          this.ffExoprtDetail.newClientEmail = "";
          this.ffExoprtDetail.newClientPhoneNumber = "";
          lead_details.forEach((element) => {
            if (this.ffExoprtDetail.newClientEmail) {
              this.ffExoprtDetail.newClientEmail =
                this.ffExoprtDetail.newClientEmail + "," + element.lead_email;
            } else {
              this.ffExoprtDetail.newClientEmail = element.lead_email;
            }

            if (this.ffExoprtDetail.newClientPhoneNumber) {
              this.ffExoprtDetail.newClientPhoneNumber =
                this.ffExoprtDetail.newClientPhoneNumber + "," + element.lead_mobile;
            } else {
              this.ffExoprtDetail.newClientPhoneNumber = element.lead_mobile;
            }
          });
        }
        let newClientPhoneNumber = this.ffExoprtDetail.newClientPhoneNumber
          .replace(/ /g, "")
          .split(",");
        console.log("newClientPhoneNumber", newClientPhoneNumber);
        newClientPhoneNumber = [...new Set(newClientPhoneNumber)];
        console.log("newClientPhoneNumber", newClientPhoneNumber);
        this.ffExoprtDetail.newClientPhoneNumber = "";
        this.ffExoprtDetail.newClientPhoneNumber = newClientPhoneNumber.join(",");
        this.ffExoprtDetail.newClientAddress = values[0].lead_address;
      }
      console.log("this.ffExoprtDetail=>", this.ffExoprtDetail);
    },

    // Added 01-02-2023 end
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// mainEnquiry.vue?33227926